import React, { useState, useEffect, useRef } from 'react';
import { Switch, FormControlLabel } from '@mui/material';
import PaginacionControl from '../components/PaginacionControl';
import debounce from 'lodash.debounce';
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, MenuItem, TextField, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Chip, Alert, CircularProgress, useTheme, useMediaQuery
} from '@mui/material';
import { saveAs } from 'file-saver';
import { exportComprobanteWorkbook, COMPROBANTE_CONFIG } from '../utils/excel/comprobanteWorkbook';
import Autocomplete from '@mui/material/Autocomplete';
import { Add, Delete, Edit, AttachFile, CloudUpload, CheckCircle, Cancel, Receipt, Gavel, Warning, Refresh, Description, Archive, Search as SearchIcon, Close } from '@mui/icons-material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import WhatsAppDialog from '../components/WhatsAppDialog';
import { GridOn } from '@mui/icons-material';
import axios from 'axios';
import Checkbox from '@mui/material/Checkbox';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ClienteRapidoDialog from '../components/ClienteRapidoDialog';
import ProductoRapidoDialog from '../components/ProductoRapidoDialog';
import ProductoBuscadorDialog, { StockAlmacenesDialog } from '../components/ProductoBuscadorDialog';

const initialDetalle = {
  producto_id: '',
  descripcion_producto: '',
  cantidad: 1,
  unidad_medida: '',
  precio_unitario: 0,
  descuento_monto: 0,
  descuento_porcentaje: 0,
  subtotal: 0,
  tipo_igv: '10',
  igv_monto: 0,
  total: 0,
  observaciones: ''
};

const getAdjuntoStartIcon = (nombre = '') => {
  const filename = String(nombre || '').toLowerCase();
  const isXml = filename.endsWith('.xml');
  const isCdr = filename.includes('cdr') || filename.startsWith('r-') || filename.endsWith('.zip');

  if (isCdr) return <CheckCircle />;
  if (isXml) return <Receipt />;
  return <AttachFile />;
};

const getAdjuntosArray = (rawAdjuntos) => {
  if (Array.isArray(rawAdjuntos)) return rawAdjuntos;
  if (typeof rawAdjuntos === 'string' && rawAdjuntos.trim().startsWith('[')) {
    try {
      const parsed = JSON.parse(rawAdjuntos);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

const findAdjuntoByTipo = (rawAdjuntos, tipo) => {
  const adjuntos = getAdjuntosArray(rawAdjuntos);
  return adjuntos.find((name) => {
    const filename = String(name || '').toLowerCase();
    const isCdr = filename.includes('cdr') || filename.startsWith('r-') || filename.endsWith('.zip');
    const isXml = filename.endsWith('.xml') && !isCdr;
    return tipo === 'cdr' ? isCdr : isXml;
  });
};

const NotaCreditoPage = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Estado para distinguir entre edición y nuevo
    const [modoEdicion, setModoEdicion] = useState(false);
    const [guardando, setGuardando] = useState(false);
    const [tiposIGV, setTiposIGV] = useState([]);
    const [loadingTiposIGV, setLoadingTiposIGV] = useState(false);
    
    // Estado para el diálogo de datos adicionales
    const [openDatosAdicionales, setOpenDatosAdicionales] = useState(false);

    // Estado para el diálogo de ANULACIÓN ELECTRÓNICA
    const [openAnulacion, setOpenAnulacion] = useState(false);
    const [BoletaAAnular, setBoletaAAnular] = useState(null);
    const [motivoAnulacion, setMotivoAnulacion] = useState('');
    const [procesandoAnulacion, setProcesandoAnulacion] = useState(false);
    const [openPdfDialog, setOpenPdfDialog] = useState(false);
    const [BoletaPdfTarget, setBoletaPdfTarget] = useState(null);
    const [pdfDescargando, setPdfDescargando] = useState(false);
    const [wspDialog, setWspDialog] = useState({ open: false, data: null });
    const [pdfFormatoSeleccionado, setPdfFormatoSeleccionado] = useState(() => localStorage.getItem('nota_credito_pdf_formato_default') || 'A4');
    const [guardarPdfComoPredeterminado, setGuardarPdfComoPredeterminado] = useState(true);
    const [pdfResolucion, setPdfResolucion] = useState({});
    const [pdfResolucionCargando, setPdfResolucionCargando] = useState(false);

    // Estado y función para almacenes
    const [almacenes, setAlmacenes] = useState([]);
    const [almacenInput, setAlmacenInput] = useState('');
    const [loadingAlmacenes, setLoadingAlmacenes] = useState(false);

    // Función para cargar almacenes
    const fetchAlmacenes = async (query = '') => {
      setLoadingAlmacenes(true);
      try {
        const res = await axios.get('/api/almacen/mis-almacenes', { params: { q: query } });
        setAlmacenes(res.data);
        if (res.data.length === 1) {
          setDetalle(prev => ({ ...prev, almacen_id: res.data[0].id }));
        }
      } catch (err) {
        setAlmacenes([]);
      }
      setLoadingAlmacenes(false);
    };

    // Debounce para evitar muchas llamadas
    const debouncedFetchAlmacenes = React.useMemo(() => debounce(fetchAlmacenes, 300), []);

    // Función para abrir el diálogo de datos adicionales
    const handleOpenDatosAdicionales = async () => {
      const BoletaId = form.id;
      if (BoletaId && BoletaId !== datosCargadosParaId.current) {
        try {
          const [resPlaca, resOC] = await Promise.all([
            axios.get(`/api/datos-adicionales/NOTA_CREDITO/${BoletaId}/placa`).catch(() => null),
            axios.get(`/api/datos-adicionales/NOTA_CREDITO/${BoletaId}/orden_compra`).catch(() => null)
          ]);
          setPlacaAdicional(resPlaca?.data?.valor || '');
          setOrdenCompraAdicional(resOC?.data?.valor || '');
          datosCargadosParaId.current = BoletaId;
        } catch {
          setPlacaAdicional('');
          setOrdenCompraAdicional('');
        }
      }
      setOpenDatosAdicionales(true);
    };
    // Función para cargar tipos IGV (debe ir antes del useEffect)
    const fetchTiposIGV = async () => {
    setLoadingTiposIGV(true);
    try {
        const res = await axios.get('/api/tipo-igv');
        setTiposIGV(res.data);
    } catch (err) {
        setTiposIGV([]);
    }
    setLoadingTiposIGV(false);
    };
    // Función para cargar condiciones de pago (debe ir antes del useEffect)
    const fetchCondicionesPago = async () => {
      setLoadingCondicionesPago(true);
      try {
        const res = await axios.get('/api/condicion-pago');
        setCondicionesPago(res.data);
        // Autoseleccionar Contado si existe
        const contado = res.data.find(c => c.descripcion.toLowerCase() === 'contado');
        if (contado) {
          setForm(f => ({ ...f, condicion_pago: contado.id }));
        }
      } catch (err) {
        setCondicionesPago([]);
      }
      setLoadingCondicionesPago(false);
    };

    const fetchTiposNotaCredito = async () => {
      try {
        const res = await axios.get('/api/tipo-nota-credito');
        setTiposNotaCredito(Array.isArray(res.data) ? res.data : []);
      } catch {
        setTiposNotaCredito([]);
      }
    };

    const fetchReferenciasNc = async () => {
      try {
        const res = await axios.get('/api/comprobante', {
          params: { search: searchReferenciaNc, tipo_comprobante: String(form.serie || '').toUpperCase().startsWith('B') ? '03' : '01' }
        });
        const rows = (res.data || []).filter(r => (r.estado_registro === 1 || r.estado_registro === true));
        setReferenciasNc(rows);
      } catch {
        setReferenciasNc([]);
      }
    };

    const seleccionarReferenciaNc = async (ref) => {
      try {
        const res = await axios.get(`/api/comprobante/${ref.id}`);
        const doc = res.data || {};
        const detallesRef = Array.isArray(doc.detalles) ? doc.detalles : [];
        const detallesCopiados = detallesRef.map((d) => ({
          ...d,
          saldo_cantidad: d.cantidad
        }));

        setForm((prev) => ({
          ...prev,
          cliente_id: doc.cliente_id || prev.cliente_id,
          moneda: doc.moneda || prev.moneda,
          tipo_cambio: doc.tipo_cambio || prev.tipo_cambio,
          condicion_pago: doc.condicion_pago_id || prev.condicion_pago,
          comprobante_referencia_id: ref.id,
          detalles: detallesCopiados,
          subtotal: doc.subtotal || 0,
          total_igv: doc.total_igv || 0,
          total: doc.total || 0,
          total_gravada: doc.total_gravada || 0,
          total_exonerada: doc.total_exonerada || 0,
          total_inafecta: doc.total_inafecta || 0,
          total_gratuita: doc.total_gratuita || 0,
          total_exportacion: doc.total_exportacion || 0,
          total_otros_cargos: doc.total_otros_cargos || 0,
          total_icbper: doc.total_icbper || 0,
          total_anticipos: doc.total_anticipos || 0,
          total_percepcion: doc.total_percepcion || 0,
          total_otros_impuestos: doc.total_otros_impuestos || 0
        }));

        setReferenciaNcLabel(`${ref.serie}-${String(ref.numero).padStart(8, '0')}`);
        setReferenciaNcSnapshot({
          referenciaId: ref.id,
          detalles: detallesRef.map((d) => ({
            producto_id: d.producto_id,
            tipo_igv: d.tipo_igv,
            cantidad: toNum(d.cantidad),
            precio_unitario: toNum(d.precio_unitario),
            subtotal: toNum(d.subtotal),
            igv_monto: toNum(d.igv_monto),
            total: toNum(d.total)
          })),
          total: toNum(doc.total),
          subtotal: toNum(doc.subtotal),
          total_igv: toNum(doc.total_igv)
        });
        setOpenReferenciaNc(false);
      } catch {
        alert('No se pudo cargar el comprobante de referencia.');
      }
    };
    const [Boletas, setBoletas] = useState([]);
    const [open, setOpen] = useState(false);
    const [verBoleta, setVerBoleta] = useState(null);
    const [tiposNotaCredito, setTiposNotaCredito] = useState([]);
    const [openReferenciaNc, setOpenReferenciaNc] = useState(false);
    const [referenciasNc, setReferenciasNc] = useState([]);
    const [searchReferenciaNc, setSearchReferenciaNc] = useState('');
    const [referenciaNcLabel, setReferenciaNcLabel] = useState('');
    const [referenciaNcSnapshot, setReferenciaNcSnapshot] = useState(null);
    const [refManualMode, setRefManualMode] = useState(false);
    const [refManualSerie, setRefManualSerie] = useState('');
    const [refManualNumero, setRefManualNumero] = useState('');
    const [refManualTipo, setRefManualTipo] = useState('01');
    const [form, setForm] = useState({
        serie: '',
        numero: '',
        fecha_emision: new Date().toLocaleDateString('en-CA'),
        fecha_validez: '',
        cliente_id: '',
        vendedor_id: '',
        moneda: 'PEN',
        tipo_cambio: 1,
        condicion_pago: 'CONTADO',
        cuotas_json: '',
        subtotal: 0,
        descuento_global: 0,
        porcentaje_descuento_global: 0,
        total_igv: 0,
        total: 0,
        observaciones: '',
        tipo_nota_credito: '',
        comprobante_referencia_id: '',
        motivo_nota: '',
        estado: 'PENDIENTE',
        detalles: [],
        adjuntos: [],
        sucursal_id: '',
        es_anticipo: false,
        anticipo_referencia_id: null,
        total_anticipos: 0,
        detraccion_aplicada: false,
        detraccion_monto: 0,
        detraccion_cuenta: '',
        detraccion_porcentaje_personalizado: false,
        detraccion_porcentaje: 12,
        retencion_aplicada: false,
        retencion_monto: 0,
    });
    const [detalle, setDetalle] = useState(initialDetalle);
    const [editingDetalle, setEditingDetalle] = useState(null);
    const [clientes, setClientes] = useState([]);
    const [clienteInput, setClienteInput] = useState('');
    const [loadingClientes, setLoadingClientes] = useState(false);
    const [openNuevoCliente, setOpenNuevoCliente] = useState(false);
    const [openNuevoProducto, setOpenNuevoProducto] = useState(false);
    const [productoInput, setProductoInput] = useState('');
    const [openBuscadorProducto, setOpenBuscadorProducto] = useState(false);
    const [openStockAlmacen, setOpenStockAlmacen] = useState(false);
    const [copiarNombreADesc, setCopiarNombreADesc] = useState(true);
    // Solo mostrar el usuario logueado como vendedor
    const [vendedores, setVendedores] = useState([]);
    const [productos, setProductos] = useState([]);
    const [monedas, setMonedas] = useState([]);
    const [condicionesPago, setCondicionesPago] = useState([]);
    const [loadingCondicionesPago, setLoadingCondicionesPago] = useState(false);
    const [monedaInput, setMonedaInput] = useState('');
    const [loadingMonedas, setLoadingMonedas] = useState(false);
    const [adjuntos, setAdjuntos] = useState([]);
    const [series, setSeries] = useState([]);
    const [serieInput, setSerieInput] = useState('');
    const [loadingSeries, setLoadingSeries] = useState(false);
    const [sucursales, setSucursales] = useState([]);
    const [sucursalInput, setSucursalInput] = useState('');
    const [loadingSucursales, setLoadingSucursales] = useState(false);
    const [unidades, setUnidades] = useState([]);
    const [detalleError, setDetalleError] = useState({ producto: false, cantidad: false, unidad_medida: false });
    const [detalleErrorMsg, setDetalleErrorMsg] = useState('');
    const [preciosIncluyenIgv, setPreciosIncluyenIgv] = useState(false);

    // Estados para búsqueda de comprobante anticipo de referencia
    const [openAnticipoSearch, setOpenAnticipoSearch] = useState(false);
    const [anticiposDisponibles, setAnticipiosDisponibles] = useState([]);
    const [filtroAnticipo, setFiltroAnticipo] = useState('');
    const [anticipNombre, setAnticipNombre] = useState('');

    // Estado para búsqueda
    const [search, setSearch] = useState("");
    const [isRefreshingList, setIsRefreshingList] = useState(false);
    const [reenviandoCpeId, setReenviandoCpeId] = useState(null);
    const [lastRefreshAt, setLastRefreshAt] = useState(null);

    // Obtener el usuario logueado (ejemplo: desde localStorage o contexto)
    const usuarioLogueado = JSON.parse(localStorage.getItem('usuario'));

    const tipoNotaCreditoCodigo = String(form.tipo_nota_credito || '').trim();
    
    // ─── Tipos individuales (Catálogo 09 SUNAT) ───────────────────────────────
    // Codigos verificados contra tipo_nota_credito_sunat (backend/sql/maestras_sunat_inserts.sql)
    // y el Catalogo 09 oficial de SUNAT -- antes 06 y 07 estaban invertidos aqui
    // (06 "Devolucion total" tenia el comportamiento que le corresponde a 07, y
    // viceversa), por lo que "Devolucion por item" no dejaba borrar items.
    // 01: Anulación de la operación         → copia exacta total
    const ncTipo01Anulacion   = tipoNotaCreditoCodigo === '01';
    // 02: Anulación por error en el RUC     → igual a 01
    const ncTipo02AnulRUC     = tipoNotaCreditoCodigo === '02';
    // 03: Corrección por error en descripción → solo descripción editable
    const ncTipo03Correccion  = tipoNotaCreditoCodigo === '03';
    // 04: Descuento global                  → todos items, qty igual, precio/dscto editable
    const ncTipo04DescGlobal  = tipoNotaCreditoCodigo === '04';
    // 05: Descuento por ítem                → mismo comportamiento que 04
    const ncTipo05DescItem    = tipoNotaCreditoCodigo === '05';
    // 06: Devolución total                  → se devuelve TODO: copia exacta, igual que anulación
    const ncTipo06DevolucionTotal = tipoNotaCreditoCodigo === '06';
    // 07: Devolución por ítem               → se devuelven 1 o mas items puntuales:
    // permite editar descripcion/cantidad y ELIMINAR los items que no se devuelven
    const ncTipo07DevolucionItem  = tipoNotaCreditoCodigo === '07';
    // 08: Bonificación                       → flexible: editar + eliminar items
    const ncTipo08Bonificacion = tipoNotaCreditoCodigo === '08';
    // 09: Disminución en el valor           → todos items, qty igual, precio/dscto editable
    const ncTipo09Disminucion = tipoNotaCreditoCodigo === '09';
    // 10: Otros conceptos                   → libre: editar + eliminar items
    const ncTipo10Otros       = tipoNotaCreditoCodigo === '10';

    // ─── Grupos de comportamiento ─────────────────────────────────────────────
    // Copia exacta: nada editable en detalle (incluye 06: una devolucion total
    // repite exactamente los mismos items/cantidades de la factura original)
    const ncGrupoCopiaExacta   = ncTipo01Anulacion || ncTipo02AnulRUC || ncTipo06DevolucionTotal;
    // Precio ajuste: todos los items de la ref., qty igual, precio/dscto editable
    const ncGrupoPrecioAjuste  = ncTipo04DescGlobal || ncTipo05DescItem || ncTipo09Disminucion;
    // Libre: permite editar la mayoría de campos y eliminar items
    const ncGrupoLibre         = ncTipo08Bonificacion || ncTipo10Otros;

    // ─── Reglas de bloqueo derivadas ─────────────────────────────────────────
    const ncBloquearAgregarDetalle  = !refManualMode; // En modo manual (ref sistema anterior) se pueden agregar items
    const ncBloquearEliminarDetalle = !(ncTipo07DevolucionItem || ncGrupoLibre); // Solo 07, 08, 10 permiten eliminar
    const ncBloquearCabeceraGeneral = !!tipoNotaCreditoCodigo && !!form.comprobante_referencia_id; // Bloquear cabecera solo cuando ya tiene tipo Y comprobante referencia
    const ncCamposPermitidosCabecera = ['motivo_nota', 'tipo_nota_credito'];
    const ncSoloDescripcionDetalle  = ncTipo03Correccion; // Tipo 03: solo descripción editable

    const toNum = (v) => Number(parseFloat(v) || 0);
    const sameAmount = (a, b) => Math.abs(toNum(a) - toNum(b)) < 0.0001;

    // Buscar tipo de cambio al cambiar la fecha de emisión si la moneda es USD
    const handleFechaEmisionChange = async (e) => {
        const nuevaFecha = e.target.value;
        setForm(prevForm => {
        const nuevoForm = { ...prevForm, fecha_emision: nuevaFecha };
        // Si la moneda ya es USD, consultar tipo de cambio
        if (nuevoForm.moneda === 'USD') {
            consultarTipoCambio(nuevaFecha);
        }
        return nuevoForm;
        });
    };

  // Función auxiliar para consultar tipo de cambio
  const consultarTipoCambio = async (fecha) => {
    try {
      const resBD = await axios.get('/api/tipo-cambio');
      const tc = resBD.data.find(x => x.fecha && x.fecha.substring(0,10) === fecha);
      if (tc && tc.venta) {
        setForm(f => ({ ...f, tipo_cambio: tc.venta }));
        return;
      }
    } catch {}
    try {
      const res = await axios.get(`/api/tipo-cambio/sunat?fecha=${fecha}`);
      if (res.data && res.data.venta) {
        setForm(f => ({ ...f, tipo_cambio: res.data.venta }));
        return;
      }
    } catch {}
    setForm(f => ({ ...f, tipo_cambio: 1 }));
  };

  console.log('usuarioLogueado:', usuarioLogueado);


    // Buscar comprobantes de tipo anticipo para referenciar
    const fetchAnticipos = async () => {
      try {
        const res = await axios.get('/api/comprobante', {
          params: { search: filtroAnticipo, tipo_comprobante: '07' }
        });
        const soloAnticipos = (res.data || []).filter(r => r.es_anticipo === 1 || r.es_anticipo === true);
        setAnticipiosDisponibles(soloAnticipos);
      } catch {
        setAnticipiosDisponibles([]);
      }
    };

    useEffect(() => {
      if (openAnticipoSearch) fetchAnticipos();
    }, [openAnticipoSearch, filtroAnticipo]);

    useEffect(() => {
        fetchTiposIGV();
      fetchTiposNotaCredito();
        fetchBoletas();
        fetchProductos();
        fetchCondicionesPago();
        fetchUnidades();
        fetchClientesAsync("");
        setModoEdicion(false); // Desactivar modo edición en carga inicial
    }, []);

    useEffect(() => {
            fetchBoletas(); 
        }, [search]);

    useEffect(() => {
      if (openReferenciaNc) {
        fetchReferenciasNc();
      }
    }, [openReferenciaNc, searchReferenciaNc, form.serie]);
    
    useEffect(() => {
        if (open) {
        fetchVendedoresAsync();
        fetchAlmacenes();
        }
    }, [open]);
    // Búsqueda asíncrona de almacenes en el Autocomplete
        useEffect(() => {
          if (almacenInput !== '') {
            debouncedFetchAlmacenes(almacenInput);
          } else if (open) {
            fetchAlmacenes();
          }
        }, [almacenInput, open]);

    const fetchUnidades = async () => {
        try {
        const res = await axios.get('/api/unidades');
        setUnidades(res.data);
        } catch (err) {
        setUnidades([]);
        }
    };

  const fetchBoletas = async () => {
    setIsRefreshingList(true);
    try {
      const res = await axios.get('/api/comprobante', { params: { search, tipo_comprobante: '07' } });
      setBoletas(res.data);
      setLastRefreshAt(new Date());
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setBoletas([]); // Si no hay Boletas, mostrar tabla vacía sin error
        setLastRefreshAt(new Date());
      } else {
        console.error('Error al obtener las Boletas:', err);
        if (window && window.console) window.console.log('BOLETA ERROR:', err);
        alert('Error al obtener las Boletas: ' + (err.response?.data?.error || err.message));
      }
    } finally {
      setIsRefreshingList(false);
    }
  };

  const puedeReenviarCpe = (nv) => {
    const estadoCpe = String(nv?.estado_cpe || '').toUpperCase();
    if (nv?.estado === 'ANULADA' || Number(nv?.estado_registro) === 0) return false;
    // Rechazado o anulado: no se reenvía, hay que emitir un comprobante nuevo
    if (estadoCpe === 'RECHAZADO' || estadoCpe === 'ANULADO') return false;
    // Permitir en estados fallidos/pendientes sin encolar
    return (
      estadoCpe === 'PENDIENTE' ||
      estadoCpe === 'REINTENTAR' ||
      estadoCpe === 'ERROR_REINTENTO' ||
      estadoCpe.startsWith('ERROR_')
    );
  };

  const reenviarCpe = async (nv) => {
    try {
      setReenviandoCpeId(nv.id);
      const usuario = usuarioLogueado ? (usuarioLogueado.username || usuarioLogueado.email || usuarioLogueado.usuario || 'api') : 'api';

      const resEncolar = await axios.post(`/api/comprobante/${nv.id}/encolar-envio`, { usuario, force: true });
      const yaActivo = !!resEncolar.data?.alreadyActive;
      const forzado = !!resEncolar.data?.forcedNow;
      const yaFinal = !!resEncolar.data?.alreadyFinal;

      if (yaFinal) {
        await fetchBoletas();
        alert(`Este comprobante ya fue enviado y resuelto ante SUNAT (estado: ${resEncolar.data?.estadoActual || 'ENVIADO'}). No se reenviará.`);
        return;
      }

      // Intentar procesar de inmediato para feedback rápido; si falla, el scheduler automático lo tomará.
      try {
        await axios.post('/api/comprobante/envio-jobs/procesar-siguiente');
      } catch (_) {
        // Silencioso: el scheduler corre cada pocos segundos.
      }

      await fetchBoletas();

      if (yaActivo && forzado) {
        alert('El comprobante ya tenía un job activo, pero se forzó su reintento inmediato.');
      } else if (yaActivo) {
        alert('Este comprobante ya tenía un job activo de envío. Se seguirá procesando automáticamente.');
      } else {
        alert('Comprobante reencolado para reenvío a SUNAT.');
      }
    } catch (err) {
      alert('No se pudo reencolar el comprobante: ' + (err.response?.data?.error || err.response?.data?.detalle || err.message));
    } finally {
      setReenviandoCpeId(null);
    }
  };

  const formatLastRefresh = (fecha) => {
    if (!fecha) return 'Sin sincronizar';
    return fecha.toLocaleTimeString('es-PE', { hour12: false });
  };
  // Búsqueda asíncrona de clientes
  const fetchClienteGenRef = React.useRef(0);
  const fetchClientesAsync = async (query = '') => {
    const gen = ++fetchClienteGenRef.current;
    setLoadingClientes(true);
    try {
      const res = await axios.get('/api/auxiliares', {
        params: { tipo: 'CLIENTE', q: query }
      });
      if (gen === fetchClienteGenRef.current) setClientes(res.data);
    } catch (err) {
      console.error('Error al buscar clientes:', err);
      if (window && window.console) window.console.log('CLIENTE ERROR:', err);
      alert('Error al buscar clientes: ' + (err.response?.data?.error || err.message));
      if (gen === fetchClienteGenRef.current) setClientes([]);
    }
    if (gen === fetchClienteGenRef.current) setLoadingClientes(false);
  };

  // Debounce para evitar muchas llamadas
  const debouncedFetchClientes = React.useMemo(() => debounce(fetchClientesAsync, 300), []);
  const skipClienteSearch = React.useRef(false);
  const fetchVendedores = async () => {
    try {
      const res = await axios.get('/api/usuarios');
      setVendedores(res.data);
    } catch (err) {
      console.error('Error al obtener vendedores:', err);
      if (window && window.console) window.console.log('VENDEDOR ERROR:', err);
      alert('Error al obtener vendedores: ' + (err.response?.data?.error || err.message));
    }
  };
  const fetchProductos = async (q = '') => {
    try {
      const params = {};
      if (form.sucursal_id) params.sucursal_id = form.sucursal_id;
      if (q) { params.search = q; params.limit = 60; }
      else if (form.sucursal_id) { params.limit = 5000; }
      const res = await axios.get('/api/productos', { params });
      setProductos(res.data);
    } catch (err) {
      console.error('Error al obtener productos:', err);
      alert('Error al obtener productos: ' + (err.response?.data?.error || err.message));
    }
  };
  const debouncedFetchProductos = React.useMemo(() => debounce(fetchProductos, 300), [form.sucursal_id]);

  // Re-cargar productos filtrados cuando cambia la sucursal seleccionada
  useEffect(() => {
    if (form.sucursal_id) fetchProductos();
  }, [form.sucursal_id]);

  const fetchMonedasAsync = async (query = '') => {
    setLoadingMonedas(true);
    try {
      const res = await axios.get('/api/monedas', {
        params: { q: query }
      });
      setMonedas(res.data);
    } catch (err) {
      console.error('Error al buscar monedas:', err);
      setMonedas([]);
    }
    setLoadingMonedas(false);
  };

  const debouncedFetchMonedas = React.useMemo(() => debounce(fetchMonedasAsync, 300), []);

  const fetchSucursalesAsync = async (query = '') => {
    setLoadingSucursales(true);
    try {
      const res = await axios.get('/api/sucursales/mis-sucursales', { params: { q: query } });
      setSucursales(res.data);
      // Seleccionar la primera sucursal por defecto solo en carga inicial (sin filtro)
      if (query === '' && res.data.length > 0) {
        setForm(f => ({ ...f, sucursal_id: f.sucursal_id || res.data[0].id }));
      }
    } catch (err) {
      console.error('Error al buscar sucursales:', err);
      setSucursales([]);
    }
    setLoadingSucursales(false);
  };

  const debouncedFetchSucursales = React.useMemo(() => debounce(fetchSucursalesAsync, 300), []);

  useEffect(() => {
    if (open) {
      fetchSucursalesAsync(''); // cargar inicial
    }
  }, [open]);

  useEffect(() => {
    if (!open) return;
    if (sucursalInput !== '') {
      debouncedFetchSucursales(sucursalInput);
    } else {
      fetchSucursalesAsync('');
    }
  }, [sucursalInput]);

  // Filtrar series por sucursal y permisos SOLO tipo NTV (Boleta)
  const fetchSeriesPorSucursalYUsuario = async (idSucursal, idUsuario) => {
    setLoadingSeries(true);
    try {
      // Series de la sucursal
      const resSeries = await axios.get(`/api/series/sucursal/${idSucursal}`);
      // Series permitidas para el usuario
      const resPermisos = await axios.get(`/api/usuario-serie/${idUsuario}`);
      const seriesPermitidas = resSeries.data.filter(serie =>
        serie.tipo_documento === '07' &&
        resPermisos.data.some(perm => perm.id === serie.id && perm.activo)
      );
      setSeries(seriesPermitidas);
      // Seleccionar la primera serie por defecto SOLO si NO está en modo edición
      if (!modoEdicion) {
        if (seriesPermitidas.length > 0) {
          setForm(f => ({ ...f, serie: seriesPermitidas[0].serie, numero: seriesPermitidas[0].correlativo_actual }));
        } else {
          setForm(f => ({ ...f, serie: '', numero: '' }));
        }
      }
    } catch (err) {
      console.error('Error al buscar series:', err);
      setSeries([]);
    }
    setLoadingSeries(false);
  };

  // Cuando cambia sucursal, cargar series filtradas por usuario
  useEffect(() => {
    if (form.sucursal_id && form.vendedor_id) {
      fetchSeriesPorSucursalYUsuario(form.sucursal_id, form.vendedor_id);
      // Al cargar series y correlativo, solo actualizar correlativo si NO está en modo edición
      if (!modoEdicion && series.length > 0) {
        // Setear correlativo automáticamente usando la primera serie permitida
        setForm(prev => ({
          ...prev,
          serie: series[0].nombre || series[0].codigo || '',
          numero: series[0].correlativo || '',
        }));
      }
      // Si está en modo edición, NO actualizar el correlativo
    }
  }, [form.sucursal_id, form.vendedor_id]);

  const handleOpen = async () => {
    setModoEdicion(false);
    setAdjuntos([]);
    // Forzar recarga de vendedores antes de abrir el formulario
    await fetchVendedoresAsync(); // Usar fetchVendedoresAsync
    // Obtener configuración de empresa para el valor por defecto de preciosIncluyenIgv
    try {
      const { obtenerEmpresaConfig } = await import('../utils/empresaConfig');
      const config = await obtenerEmpresaConfig();
      if (config && (config.precios_incluyen_igv === 1 || config.precios_incluyen_igv === true)) {
        setPreciosIncluyenIgv(true);
      } else {
        setPreciosIncluyenIgv(false);
      }
    } catch (err) {
      setPreciosIncluyenIgv(false);
    }
    // Seleccionar automáticamente el vendedor logueado
    if (usuarioLogueado) {
      setForm(f => ({
        ...f,
        id: null,
        detalles: [],
        adjuntos: [],
        fecha_emision: new Date().toLocaleDateString('en-CA'),
        fecha_validez: '',
        vendedor_id: usuarioLogueado.id,
        cliente_id: '', // Limpiar cliente al abrir nueva cotización
        moneda: 'PEN', // No arrastrar moneda de un comprobante editado previamente
        tipo_cambio: 1,
        condicion_pago: (condicionesPago.find(c => c.descripcion?.toLowerCase() === 'contado') || {}).id || '',
        subtotal: 0,
        total_igv: 0,
        total: 0,
        serie: '',   // Limpiar serie
        numero: '',  // Limpiar correlativo
        observaciones: '', // Limpiar observaciones
        es_anticipo: false,
        anticipo_referencia_id: null,
        total_anticipos: 0,
        detraccion_aplicada: false,
        detraccion_monto: 0,
        detraccion_cuenta: '',
        detraccion_porcentaje_personalizado: false,
        detraccion_porcentaje: 12,
        retencion_aplicada: false,
        retencion_monto: 0,
        tipo_nota_credito: '',
        comprobante_referencia_id: '',
        motivo_nota: '',
      }));
    } else {
      setForm(f => ({
        ...f,
        id: null,
        detalles: [],
        adjuntos: [],
        fecha_emision: new Date().toLocaleDateString('en-CA'),
        fecha_validez: '',
        vendedor_id: '',
        cliente_id: '', // Limpiar cliente al abrir nueva cotización
        moneda: 'PEN', // No arrastrar moneda de un comprobante editado previamente
        tipo_cambio: 1,
        condicion_pago: (condicionesPago.find(c => c.descripcion?.toLowerCase() === 'contado') || {}).id || '',
        subtotal: 0,
        total_igv: 0,
        total: 0,
        serie: '',   // Limpiar serie
        numero: '',  // Limpiar correlativo
        observaciones: '', // Limpiar observaciones
        es_anticipo: false,
        anticipo_referencia_id: null,
        total_anticipos: 0,
        detraccion_aplicada: false,
        detraccion_monto: 0,
        detraccion_cuenta: '',
        detraccion_porcentaje_personalizado: false,
        detraccion_porcentaje: 12,
        retencion_aplicada: false,
        retencion_monto: 0,
        tipo_nota_credito: '',
        comprobante_referencia_id: '',
        motivo_nota: '',
      }));
    }

    // Esperar un ciclo para asegurar que el form se limpió antes de asignar la serie
    setTimeout(() => {
      fetchSeriesPorSucursalYUsuario(form.sucursal_id, form.vendedor_id);
      if (!modoEdicion && series.length > 0) {
        // Setear correlativo automáticamente usando la primera serie permitida
        setForm(prev => ({
          ...prev,
          serie: series[0].nombre || series[0].codigo || '',
          numero: series[0].correlativo || '',
        }));
      }
    }, 0);
    //setModoEdicion(true); // Activar modo edición al abrir para editar
    setReferenciaNcSnapshot(null);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setForm({ ...form, detalles: [], adjuntos: [], es_anticipo: false, anticipo_referencia_id: null, total_anticipos: 0, detraccion_aplicada: false, detraccion_monto: 0, detraccion_cuenta: '', detraccion_porcentaje_personalizado: false, detraccion_porcentaje: 12, retencion_aplicada: false, retencion_monto: 0, cuotas_json: '', tipo_nota_credito: '', comprobante_referencia_id: '', motivo_nota: '' });
    setDetalle(initialDetalle);
    setEditingDetalle(null);
    setModoEdicion(false);
    setPlacaAdicional('');
    setOrdenCompraAdicional('');
    datosCargadosParaId.current = null;
    setAnticipNombre('');
    setCuotas([]);
    setNumeroCuotas(3);
    setFechaCuota('');
    setMontoCuota(0);
    setMostrarFinanciero(false);
    setReferenciaNcLabel('');
    setReferenciaNcSnapshot(null);
    setRefManualMode(false);
    setRefManualSerie('');
    setRefManualNumero('');
    setRefManualTipo('01');
  };

  // Función para detectar si la condición de pago es crédito
  const esCredito = () => {
    const condPago = condicionesPago.find(c => c.id === form.condicion_pago);
    if (!condPago) return false;
    // Usar el campo 'tipo' de la BD para detectar si es crédito
    return (condPago.tipo || '').toLowerCase() === 'credito';
  };

  // Obtener dias de crédito de la condición de pago seleccionada
  const obtenerDiasCredito = () => {
    const condPago = condicionesPago.find(c => c.id === form.condicion_pago);
    return condPago && condPago.dias_credito ? parseInt(condPago.dias_credito) : 30;
  };

  // Calcular cuotas OPCIÓN A: 1 sola cuota en dias_credito, pero divisible en múltiples si user quiere
  const calcularCuotasOpcionA = (numeroDivisiones = 1) => {
    if (!form.total || numeroDivisiones <= 0) return;
    const diasCredito = obtenerDiasCredito();
    // Monto neto pendiente de pago: no incluye retención ni detracción (el cliente
    // no paga esa parte directamente) — mismo cálculo que se usa al grabar.
    const montoNeto = Number(form.total)
      - (form.retencion_aplicada ? Number(form.retencion_monto || 0) : 0)
      - (form.detraccion_aplicada ? Number(form.detraccion_monto || 0) : 0);
    const montoXCuota = montoNeto / Number(numeroDivisiones);
    const nuevasCuotas = [];
    const fechaEmision = new Date(form.fecha_emision);
    
    for (let i = 0; i < numeroDivisiones; i++) {
      const fechaVenc = new Date(fechaEmision);
      // Distribuir los días entre las cuotas
      const diasPorCuota = Math.ceil((diasCredito / numeroDivisiones) * (i + 1));
      fechaVenc.setDate(fechaVenc.getDate() + diasPorCuota);
      nuevasCuotas.push({
        numero: i + 1,
        fecha: fechaVenc.toISOString().substring(0, 10),
        monto: montoXCuota
      });
    }
    setCuotas(nuevasCuotas);
    setForm(f => ({ ...f, cuotas_json: JSON.stringify(nuevasCuotas) }));
  };

  // useEffect para limpiar cuotas si cambia a no-crédito
  useEffect(() => {
    if (!esCredito()) {
      setCuotas([]);
      setNumeroCuotas(0);
      setForm(f => ({ ...f, cuotas_json: '' }));
    }
  }, [form.condicion_pago, open, condicionesPago]);
  const agregarCuotaManual = () => {
    if (!fechaCuota || Number(montoCuota) <= 0) {
      alert('Ingresa una fecha y monto válidos');
      return;
    }
    const nuevaCuota = {
      numero: cuotas.length + 1,
      fecha: fechaCuota,
      monto: Number(montoCuota)
    };
    const nuevosCuotas = [...cuotas, nuevaCuota];
    setCuotas(nuevosCuotas);
    setForm(f => ({ ...f, cuotas_json: JSON.stringify(nuevosCuotas) }));
    setFechaCuota('');
    setMontoCuota(0);
  };

  const handleFormChange = (e) => {
    if (ncBloquearCabeceraGeneral && !ncCamposPermitidosCabecera.includes(e.target.name)) {
      return;
    }
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleDetalleChange = (e) => {
    const { name, value } = e.target;
    // Copia exacta (01, 02, 06): nada editable
    if (ncGrupoCopiaExacta) {
      return;
    }
    // Tipo 03: solo descripción editable
    if (ncTipo03Correccion && name !== 'descripcion_producto') {
      return;
    }
    // Tipo 07 (Devolución por ítem): permite editar descripción y cantidad devuelta
    if (ncTipo07DevolucionItem && !['descripcion_producto', 'cantidad'].includes(name)) {
      return;
    }
    // Grupo precio ajuste (04, 05, 07, 09): qty bloqueada, precio/dscto editables
    if (ncGrupoPrecioAjuste && name === 'cantidad') {
      return;
    }
    // Grupo libre (08, 10): todo permitido salvo producto_id
    // (no se cambia el producto base, solo se ajustan cantidades/precios)
    if (name === 'producto_id') {
      const prod = productos.find(p => p.id === value);
      setDetalle({
        ...detalle,
        producto_id: value,
        descripcion_producto: copiarNombreADesc ? (prod?.nombre || '') : '',
        unidad_medida: prod && prod.unidad_medida_id ? prod.unidad_medida_id : '',
        precio_unitario: prod && prod.precio != null ? prod.precio : detalle.precio_unitario
      });
    } else {
      setDetalle({ ...detalle, [name]: value });
    }
    setDetalleError({ producto: false, cantidad: false, unidad_medida: false, almacen: false });
    setDetalleErrorMsg('');
  };

  const handleBuscadorSelectNC = (prod) => {
    setDetalle(d => ({
      ...d,
      producto_id: prod.id,
      descripcion_producto: copiarNombreADesc ? (prod.nombre || '') : d.descripcion_producto,
      unidad_medida: prod.unidad_medida_id || d.unidad_medida,
      precio_unitario: prod.precio != null ? prod.precio : d.precio_unitario,
    }));
    setProductoInput(prod?.nombre || '');
    setDetalleError(e => ({ ...e, producto: false }));
    setDetalleErrorMsg('');
  };

  const calcularDetalle = (d) => {
    const cantidad = parseFloat(d.cantidad) || 0;
    const precio = parseFloat(d.precio_unitario) || 0;
    const desc = parseFloat(d.descuento_monto) || 0;
    const descP = parseFloat(d.descuento_porcentaje) || 0;
    const tasaIgv = 0.18;
    const tipoIGV = Array.isArray(tiposIGV) ? tiposIGV.find(t => t.codigo === d.tipo_igv) : undefined;
    const codigoIgv = tipoIGV?.codigo || d.tipo_igv || '10';
    let subtotal = 0, igv = 0, total = 0;
    const codigosGratuitos = ['21', '31', '32', '33', '34', '35'];
    const esGratuito = codigosGratuitos.includes(codigoIgv);
    const codigosGravados = ['10','11','12','13','14','15','16','17'];
    if (esGratuito) {
      subtotal = Math.round((precio * cantidad - desc - (precio * cantidad * descP / 100)) * 10000) / 10000;
      igv = 0;
      total = 0;
    } else if (preciosIncluyenIgv && codigosGravados.includes(codigoIgv)) {
      const precioFinal = precio * cantidad - desc - (precio * cantidad * descP / 100);
      subtotal = Math.round((precioFinal / (1 + tasaIgv)) * 10000) / 10000;
      igv = Math.round((precioFinal - subtotal) * 10000) / 10000;
      total = Math.round(precioFinal * 10000) / 10000;
    } else {
      subtotal = Math.round((precio * cantidad - desc - (precio * cantidad * descP / 100)) * 10000) / 10000;
      if (codigosGravados.includes(codigoIgv)) {
        igv = Math.round(subtotal * tasaIgv * 10000) / 10000;
      } else {
        igv = 0;
      }
      total = Math.round((subtotal + igv) * 10000) / 10000;
    }
    return { ...d, subtotal, igv_monto: igv, total };
  };
  // Estado para mostrar/ocultar el resumen por tipo de IGV
  const [mostrarResumenIGV, setMostrarResumenIGV] = useState(false);
  // Estado para mostrar/ocultar opciones financieras (Anticipo, Detracción, Retención, Cuotas)
  const [mostrarFinanciero, setMostrarFinanciero] = useState(false);
  // Estado para cuotas de pago
  const [cuotas, setCuotas] = useState([]);
  const [numeroCuotas, setNumeroCuotas] = useState(0);
  const [fechaCuota, setFechaCuota] = useState('');
  const [montoCuota, setMontoCuota] = useState(0);

  const agregarDetalle = () => {
    if (ncBloquearAgregarDetalle) {
      alert('Este tipo de nota de credito no permite agregar nuevos detalles. Usa Jalar Referencia y ajusta solo los campos permitidos.');
      return;
    }
    let error = false;
    let errorObj = { producto: false, cantidad: false, unidad_medida: false };
    let errorMsg = '';
    if (!detalle.producto_id) {
      error = true;
      errorObj.producto = true;
      errorMsg = 'Debes seleccionar un producto.';
    }
    if (!detalle.cantidad || isNaN(detalle.cantidad) || Number(detalle.cantidad) <= 0) {
      error = true;
      errorObj.cantidad = true;
      errorMsg = errorMsg ? 'Selecciona un producto y una cantidad mayor a 0.' : 'La cantidad debe ser mayor a 0.';
    }
    if (!detalle.unidad_medida) {
      error = true;
      errorObj.unidad_medida = true;
      errorMsg = errorMsg ? 'Selecciona producto, cantidad y unidad de medida.' : 'Debes seleccionar una unidad de medida.';
    }
    if (!detalle.almacen_id) {
      error = true;
      errorObj.almacen = true;
      errorMsg = errorMsg ? 'Selecciona producto, cantidad, unidad de medida y almacén.' : 'Debes seleccionar un almacén.';
    }
    if (error) {
      setDetalleError(errorObj);
      setDetalleErrorMsg(errorMsg);
      return;
    }
    // Si la descripción está vacía, usar el nombre del producto seleccionado
    let descripcionFinal = detalle.descripcion_producto;
    if (!descripcionFinal) {
      const prod = productos.find(p => p.id === detalle.producto_id);
      descripcionFinal = prod && prod.nombre ? prod.nombre : '';
    }
    // Obtener objeto de unidad de medida
    const unidadObj = unidades.find(u => u.id === detalle.unidad_medida);
    const almacenObj = almacenes.find(a => a.id === detalle.almacen_id);

    const det = calcularDetalle({
      ...detalle,
      descripcion_producto: descripcionFinal,
      unidad_medida_id: unidadObj ? unidadObj.id : null,
      unidad_medida: unidadObj ? unidadObj.abreviatura : '',
      almacen_id: almacenObj ? almacenObj.id : ''
    });
    setForm({ ...form, detalles: [...form.detalles, det] });
    setDetalle(initialDetalle);
    setProductoInput('');
    fetchProductos();
    setEditingDetalle(null);
    setDetalleError({ producto: false, cantidad: false, unidad_medida: false, almacen: false });
    setDetalleErrorMsg('');
  };

  const editarDetalle = (idx) => {
    const d = form.detalles[idx];
    // Buscar el objeto de unidad de medida por abreviatura o id
    let unidadObj = null;
    // Si solo tienes abreviatura, busca el id correspondiente
    if (d.unidad_medida_id) {
      unidadObj = unidades.find(u => u.id === d.unidad_medida_id);
    } else if (d.unidad_medida) {
      unidadObj = unidades.find(u => u.abreviatura === d.unidad_medida || u.id === d.unidad_medida);
    }
    setDetalle({
      ...d,
      unidad_medida: unidadObj ? unidadObj.id : '',
      unidad_medida_id: unidadObj ? unidadObj.id : null
    });
    setProductoInput(productos.find(p => p.id === d.producto_id)?.nombre || '');
    setEditingDetalle(idx);
  };

  const actualizarDetalle = () => {
    // Copia exacta (01, 02): nada editable
    if (ncGrupoCopiaExacta) {
      alert('Este tipo de nota de credito no permite editar detalles (copia exacta de la factura).');
      return;
    }
    // Tipo 03: solo descripción editable
    if (ncTipo03Correccion) {
      const actual = form.detalles[editingDetalle] || {};
      const actualizado = {
        ...actual,
        descripcion_producto: detalle.descripcion_producto
      };
      setForm({ ...form, detalles: form.detalles.map((d, idx) => idx === editingDetalle ? actualizado : d) });
      setDetalle(initialDetalle);
      setProductoInput('');
      fetchProductos();
      setEditingDetalle(null);
      return;
    }
    // Tipo 07 (Devolución por ítem): permite editar descripción y cantidad devuelta
    if (ncTipo07DevolucionItem) {
      const actual = form.detalles[editingDetalle] || {};
      const actualizado = {
        ...actual,
        descripcion_producto: detalle.descripcion_producto,
        cantidad: detalle.cantidad
      };
      setForm({ ...form, detalles: form.detalles.map((d, idx) => idx === editingDetalle ? actualizado : d) });
      setDetalle(initialDetalle);
      setProductoInput('');
      fetchProductos();
      setEditingDetalle(null);
      return;
    }
    // Grupo precio ajuste (04, 05, 07, 09) y grupo libre (08, 10):
    // precio_unitario, descuento, descripción editables; cantidad se toma del original (04/05/09)
    // Para 08 y 10 también cantidad es editable
    if (ncGrupoPrecioAjuste) {
      // Preservar cantidad original, solo precio/descuento/descripción cambia
      const actual = form.detalles[editingDetalle] || {};
      const detalleParaCalc = {
        ...actual,
        descripcion_producto: detalle.descripcion_producto,
        precio_unitario: detalle.precio_unitario,
        descuento_monto: detalle.descuento_monto,
        descuento_porcentaje: detalle.descuento_porcentaje,
        // cantidad se mantiene igual que la original
      };
      const det = calcularDetalle(detalleParaCalc);
      setForm({ ...form, detalles: form.detalles.map((d, idx) => idx === editingDetalle ? det : d) });
      setDetalle(initialDetalle);
      setProductoInput('');
      fetchProductos();
      setEditingDetalle(null);
      return;
    }
    // Grupo libre (08, 10): todo editable (precio + cantidad + descripción)
    if (!detalle.almacen_id) {
      setDetalleError(e => ({ ...e, almacen: true }));
      setDetalleErrorMsg('Debes seleccionar un almacén.');
      return;
    }
    let descripcionFinal = detalle.descripcion_producto;
    if (!descripcionFinal) {
      const prod = productos.find(p => p.id === detalle.producto_id);
      descripcionFinal = prod && prod.nombre ? prod.nombre : '';
    }
    const unidadObj = unidades.find(u => u.id === detalle.unidad_medida);
    const almacenObj = almacenes.find(a => a.id === detalle.almacen_id);
    const det = calcularDetalle({
      ...detalle,
      descripcion_producto: descripcionFinal,
      unidad_medida_id: unidadObj ? unidadObj.id : null,
      unidad_medida: unidadObj ? unidadObj.abreviatura : '',
      almacen_id: almacenObj ? almacenObj.id : '',
    });
    setForm({ ...form, detalles: form.detalles.map((d, idx) => idx === editingDetalle ? det : d) });
    setDetalle(initialDetalle);
    setProductoInput('');
    fetchProductos();
    setEditingDetalle(null);
  };

  const eliminarDetalle = (idx) => {
    if (ncBloquearEliminarDetalle) {
      alert('Este tipo de nota de credito no permite eliminar detalles.');
      return;
    }
    const nuevos = form.detalles.filter((_, i) => i !== idx);
    setForm({ ...form, detalles: nuevos });
  };

  const handleAdjunto = (e) => {
    const files = Array.from(e.target.files);
    setAdjuntos([...adjuntos, ...files]);
    setForm({ ...form, adjuntos: [...form.adjuntos, ...files] });
  };

  const calcularTotales = () => {
    // Definir códigos según tabla SUNAT
    const codigosGravados = ['10','11','12','13','14','15','16','17'];
    const codigosExonerados = ['20','21'];
    const codigosInafectos = ['30','31','32','33','34','35','36'];
    const codigosExportacion = ['40'];
    const codigosGratuitos = ['21','31','32','33','34','35'];

    let subtotal = 0, total_igv = 0, total = 0;
    let total_gravada = 0, total_exonerada = 0, total_inafecta = 0, total_gratuita = 0, total_exportacion = 0;
    let total_otros_cargos = 0, total_icbper = 0, total_anticipos = 0, total_percepcion = 0, total_otros_impuestos = 0;

    form.detalles.forEach(d => {
      const tipoIGV = Array.isArray(tiposIGV) ? tiposIGV.find(t => t.codigo === d.tipo_igv) : undefined;
      // Fallback a d.tipo_igv directo cuando tiposIGV aun no cargo (evita que
      // total_gravada quede en 0 mientras total_igv/total si se calculan bien).
      const cod = tipoIGV?.codigo || d.tipo_igv;
      const montoTotal = parseFloat(d.total) || 0;
      const montoSubtotal = parseFloat(d.subtotal) || 0;
      // Sumar por tipo (base imponible = subtotal sin IGV)
      if (codigosGravados.includes(cod)) total_gravada += montoSubtotal;
      if (codigosExonerados.includes(cod)) total_exonerada += montoSubtotal;
      if (codigosInafectos.includes(cod)) total_inafecta += montoSubtotal;
      if (codigosExportacion.includes(cod)) total_exportacion += montoSubtotal;
      if (codigosGratuitos.includes(cod)) total_gratuita += montoSubtotal;
      // Sumar totales generales (solo si NO es gratuito)
      if (!codigosGratuitos.includes(cod)) {
        subtotal += montoSubtotal;
        total_igv += parseFloat(d.igv_monto) || 0;
        total += montoTotal;
      }
    });
    setForm(f => ({
      ...f,
      subtotal,
      total_igv,
      total,
      total_gravada,
      total_exonerada,
      total_inafecta,
      total_gratuita,
      total_exportacion,
      total_otros_cargos,
      total_icbper,
      total_anticipos,
      total_percepcion,
      total_otros_impuestos
    }));
  };

  useEffect(() => {
    if (form.detalles.length > 0) calcularTotales();
  }, [form.detalles]);

  const handleSubmit = async () => {
    if (guardando) return; // Evita doble envío por doble clic mientras se está grabando
    setGuardando(true);
    try {
    if (!form.detalles || form.detalles.length === 0) {
      alert('Debe agregar al menos un producto o servicio al detalle antes de guardar.');
      return;
    }
    const itemsSinProducto = form.detalles.filter(d => !d.producto_id);
    if (itemsSinProducto.length > 0) {
      const descripciones = itemsSinProducto.map(d => d.descripcion_producto || d.descripcion || '(sin descripción)').join(', ');
      alert(`Falta seleccionar un producto para: ${descripciones}. Esto suele pasar al jalar ítems de una guía que no tenía un producto asignado — selecciona uno del buscador antes de guardar.`);
      return;
    }
    if (!form.tipo_nota_credito) {
      alert('Selecciona el tipo de nota de credito.');
      return;
    }
    if (!refManualMode && !form.comprobante_referencia_id) {
      alert('Selecciona el comprobante de referencia (Factura o Boleta).');
      return;
    }
    if (refManualMode && (!refManualSerie.trim() || !refManualNumero.trim())) {
      alert('Ingresa la serie y número del comprobante de referencia del sistema anterior.');
      return;
    }
    if (!form.motivo_nota || String(form.motivo_nota).trim().length < 5) {
      alert('Ingresa un motivo de nota valido (minimo 5 caracteres).');
      return;
    }
    const tiposConValidacionEstricta = ['01', '02', '03', '04', '05', '06', '07', '09'];
    if (!refManualMode && tiposConValidacionEstricta.includes(tipoNotaCreditoCodigo) && !form.id) {
      if (!referenciaNcSnapshot || Number(referenciaNcSnapshot.referenciaId) !== Number(form.comprobante_referencia_id)) {
        alert('Para este tipo de nota de credito debes volver a jalar la referencia antes de guardar.');
        return;
      }
    }

    // Validación de tipos 01, 02, 06, 07 (especificaciones SUNAT) — omitir en modo manual
    // 06 (Devolución total) se valida igual que 01/02: se devuelve TODO, copia
    // exacta de la factura (antes esta validacion solo cubria 01/02 y dejaba
    // pasar el tipo 06 sin ningun control real de "todo igual a la factura").
    if (!refManualMode && (tipoNotaCreditoCodigo === '01' || tipoNotaCreditoCodigo === '02' || tipoNotaCreditoCodigo === '06') && referenciaNcSnapshot) {
      // Tipos 01, 02 (Anulación) y 06 (Devolución total): Debe ser copia exacta de factura
      const label = tipoNotaCreditoCodigo === '01' ? 'Anulación (tipo 01)' : tipoNotaCreditoCodigo === '02' ? 'Anulación por error en RUC (tipo 02)' : 'Devolución total (tipo 06)';
      if (form.detalles.length !== referenciaNcSnapshot.detalles.length) {
        alert(`${label}: debes incluir TODOS los items exactos de la factura.`);
        return;
      }
      for (let i = 0; i < form.detalles.length; i += 1) {
        const actual = form.detalles[i] || {};
        const base = referenciaNcSnapshot.detalles[i] || {};
        if (!sameAmount(actual.cantidad, base.cantidad) || !sameAmount(actual.precio_unitario, base.precio_unitario)) {
          alert(`${label}: cantidad y precio deben ser idénticos a la factura.`);
          return;
        }
      }
      if (!sameAmount(form.subtotal, referenciaNcSnapshot.subtotal) || !sameAmount(form.total_igv, referenciaNcSnapshot.total_igv) || !sameAmount(form.total, referenciaNcSnapshot.total)) {
        alert(`${label}: totales deben ser idénticos a la factura.`);
        return;
      }
    }

    // Tipos 04, 05, 09: todos los items de la ref., misma qty, precio/dscto puede cambiar
    if (!refManualMode && ['04', '05', '09'].includes(tipoNotaCreditoCodigo) && referenciaNcSnapshot) {
      const labels = { '04': 'Descuento global (tipo 04)', '05': 'Descuento por ítem (tipo 05)', '09': 'Disminución en el valor (tipo 09)' };
      const label = labels[tipoNotaCreditoCodigo];
      if (form.detalles.length !== referenciaNcSnapshot.detalles.length) {
        alert(`${label}: debes incluir TODOS los items de la factura.`);
        return;
      }
      for (let i = 0; i < form.detalles.length; i += 1) {
        const actual = form.detalles[i] || {};
        const base = referenciaNcSnapshot.detalles[i] || {};
        if (!sameAmount(actual.cantidad, base.cantidad)) {
          alert(`${label}: la cantidad de cada item debe ser igual a la factura (solo precios/descuentos pueden cambiar).`);
          return;
        }
        if (String(actual.producto_id || '') !== String(base.producto_id || '')) {
          alert(`${label}: los items deben coincidir con los de la factura.`);
          return;
        }
        // El nuevo precio + dscto debe ser menor o igual al original (es una reducción)
        if (Number(actual.total) > Number(base.total) + 0.01) {
          alert(`${label}: el total por item no puede ser mayor al de la factura original (es un descuento/reducción).`);
          return;
        }
      }
    }

    if (!refManualMode && tipoNotaCreditoCodigo === '07' && referenciaNcSnapshot) {
      // Tipo 07 (Devolución por ítem): Puede ser subset de items con cantidades menores
      // Validar que cada item en NC existe en referencia y cantidad <= cantidad original
      const refDetalles = referenciaNcSnapshot.detalles || [];
      for (let i = 0; i < form.detalles.length; i += 1) {
        const actual = form.detalles[i] || {};
        // Buscar item equivalente en referencia por producto_id y tipo_igv
        const baseMatch = refDetalles.find(b =>
          String(b.producto_id || '') === String(actual.producto_id || '') &&
          String(b.tipo_igv || '') === String(actual.tipo_igv || '')
        );
        if (!baseMatch) {
          alert('Devolución por ítem (tipo 07): todos los items deben estar en la factura original.');
          return;
        }
        if (Number(actual.cantidad) > Number(baseMatch.cantidad)) {
          alert(`Devolución por ítem (tipo 07): cantidad de ${actual.descripcion} no puede ser mayor que la factura.`);
          return;
        }
        // Validar que precio unitario sea igual
        if (!sameAmount(actual.precio_unitario, baseMatch.precio_unitario)) {
          alert(`Devolución por ítem (tipo 07): precio unitario debe coincidir con factura para ${actual.descripcion}.`);
          return;
        }
      }
      // Validar totales sean proporcionales (cada item reducido proportionalmente)
      let totalRefProporcional = 0, totalIgvRefProporcional = 0, subtotalRefProporcional = 0;
      for (let i = 0; i < form.detalles.length; i += 1) {
        const actual = form.detalles[i] || {};
        const baseMatch = refDetalles.find(b =>
          String(b.producto_id || '') === String(actual.producto_id || '') &&
          String(b.tipo_igv || '') === String(actual.tipo_igv || '')
        );
        const ratio = Number(actual.cantidad) / Number(baseMatch.cantidad);
        subtotalRefProporcional += Number(baseMatch.subtotal || 0) * ratio;
        totalIgvRefProporcional += Number(baseMatch.igv_monto || 0) * ratio;
        totalRefProporcional += Number(baseMatch.total || 0) * ratio;
      }
      if (!sameAmount(form.subtotal, subtotalRefProporcional) || !sameAmount(form.total_igv, totalIgvRefProporcional) || !sameAmount(form.total, totalRefProporcional)) {
        alert('Devolución por ítem (tipo 07): totales debe ser proporcionales a las cantidades devueltas.');
        return;
      }
    }

    if (!refManualMode && tipoNotaCreditoCodigo === '03' && referenciaNcSnapshot) {
      if (form.detalles.length !== referenciaNcSnapshot.detalles.length) {
        alert('La correccion por descripcion debe mantener la misma cantidad de items de la referencia.');
        return;
      }
      for (let i = 0; i < form.detalles.length; i += 1) {
        const actual = form.detalles[i] || {};
        const base = referenciaNcSnapshot.detalles[i] || {};
        const monetarioOk =
          sameAmount(actual.cantidad, base.cantidad) &&
          sameAmount(actual.precio_unitario, base.precio_unitario) &&
          sameAmount(actual.subtotal, base.subtotal) &&
          sameAmount(actual.igv_monto, base.igv_monto) &&
          sameAmount(actual.total, base.total);
        const estructuraOk =
          String(actual.producto_id || '') === String(base.producto_id || '') &&
          String(actual.tipo_igv || '') === String(base.tipo_igv || '');
        if (!monetarioOk || !estructuraOk) {
          alert('En tipo 03 solo puedes modificar la descripcion. Cantidad, precio, IGV y total deben quedar igual que la referencia.');
          return;
        }
      }
    }

    // Subir adjuntos al backend antes de guardar cotización
    let adjuntos_json = '[]';
    if (adjuntos.length > 0) {
      const formData = new FormData();
      formData.append('serie', form.serie);
      formData.append('numero', form.numero);
      adjuntos.forEach(f => formData.append('adjuntos', f));
      try {
        const res = await axios.post('/api/comprobante/upload-adjuntos', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (res.data.success) {
          adjuntos_json = JSON.stringify(res.data.files);
        }
      } catch (err) {
        alert('Error al subir adjuntos: ' + (err.response?.data?.error || err.message));
        return;
      }
    }
    // Obtener objeto de condición de pago seleccionado
    const detallesConAlmacen = form.detalles.map(d => {
      // Buscar siempre el objeto de unidad de medida por id o abreviatura
      let unidadObj = null;
      if (d.unidad_medida_id) {
        unidadObj = unidades.find(u => u.id === d.unidad_medida_id);
      } else if (d.unidad_medida) {
        unidadObj = unidades.find(u => u.abreviatura === d.unidad_medida || u.id === d.unidad_medida);
      }
      return {
        ...d,
        almacen_id: d.almacen_id || form.almacen_id,
        unidad_medida_id: unidadObj ? unidadObj.id : null,
        unidad_medida: unidadObj ? unidadObj.abreviatura : ''
      };
    });
    const condicionPagoObj = condicionesPago.find(c => c.id === form.condicion_pago);
    const data = {
      ...form,
      detalles: detallesConAlmacen,
      fecha_validez: form.fecha_validez && !isNaN(new Date(form.fecha_validez)) ? form.fecha_validez : null,
      adjuntos_json,
      condicion_pago_id: condicionPagoObj ? condicionPagoObj.id : null,
      condicion_pago: condicionPagoObj ? condicionPagoObj.descripcion : '',
      ref_manual: refManualMode && refManualSerie.trim() && refManualNumero.trim()
        ? `${refManualSerie.trim()}|${refManualNumero.trim()}|${String(form.serie || '').toUpperCase().startsWith('B') ? '03' : '01'}`
        : undefined,
      total_gravada: form.total_gravada,
      total_exonerada: form.total_exonerada,
      total_inafecta: form.total_inafecta,
      total_gratuita: form.total_gratuita,
      total_exportacion: form.total_exportacion,
      total_otros_cargos: form.total_otros_cargos,
      total_icbper: form.total_icbper,
      total_anticipos: form.total_anticipos,
      total_percepcion: form.total_percepcion,
      total_otros_impuestos: form.total_otros_impuestos,
      usuario_creacion: usuarioLogueado ? (usuarioLogueado.username || usuarioLogueado.email || usuarioLogueado.usuario || '') : '',
      usuario_modificacion: usuarioLogueado ? (usuarioLogueado.username || usuarioLogueado.email || usuarioLogueado.usuario || '') : ''
    };
    // Al crear (no editar), no enviar el número: el "siguiente número" mostrado en
    // el formulario es solo referencial y puede quedar desactualizado (dos notas de
    // crédito creadas sin refrescar la pantalla). Dejar que el backend lo asigne de
    // forma atómica evita duplicados.
    if (!form.id) delete data.numero;
    // Log para verificar los datos enviados
    console.log('Datos enviados a backend (boleta):', data);
    // Si existe id, actualizar; si no, crear
    let BoletasId = form.id;
    try {
      if (form.id) {
        await axios.put(`/api/comprobante/${form.id}`, { ...data, tipo_comprobante: '07' });
      } else {
        const res = await axios.post('/api/comprobante', { ...data, tipo_comprobante: '07' });
        BoletasId = res.data.id || res.data.insertId;
      }
    } catch (err) {
      const d = err.response?.data;
      if (d?.tipo === 'CORRELATIVO_DUPLICADO') { setCorrelativoError(d); return; }
      alert(d?.detalle || d?.error || 'Error al guardar la nota de crédito');
      return;
    }
    // Guardar datos adicionales
    const _userAdic = usuarioLogueado ? (usuarioLogueado.username || usuarioLogueado.email || usuarioLogueado.usuario || '') : '';
    if (BoletasId) {
      const adicSave = [];
      if (ordenCompraAdicional.trim() !== '') adicSave.push(axios.post('/api/datos-adicionales', { comprobante_tipo: 'NOTA_CREDITO', comprobante_id: BoletasId, campo: 'orden_compra', valor: ordenCompraAdicional.trim(), usuario_creacion: _userAdic }));
      if (placaAdicional.trim() !== '') adicSave.push(axios.post('/api/datos-adicionales', { comprobante_tipo: 'NOTA_CREDITO', comprobante_id: BoletasId, campo: 'placa', valor: placaAdicional.trim(), usuario_creacion: _userAdic }));
      if (form.detraccion_aplicada && form.detraccion_porcentaje_personalizado) adicSave.push(axios.post('/api/datos-adicionales', { comprobante_tipo: 'NOTA_CREDITO', comprobante_id: BoletasId, campo: 'detraccion_porcentaje', valor: String(form.detraccion_porcentaje), usuario_creacion: _userAdic }));
      if (refManualMode && refManualSerie.trim() && refManualNumero.trim()) {
        adicSave.push(axios.post('/api/datos-adicionales', { comprobante_tipo: 'NOTA_CREDITO', comprobante_id: BoletasId, campo: 'ref_manual', valor: `${refManualSerie.trim()}|${refManualNumero.trim()}|${String(form.serie || '').toUpperCase().startsWith('B') ? '03' : '01'}`, usuario_creacion: _userAdic }));
      }
      if (adicSave.length) await Promise.all(adicSave);
    }
    fetchBoletas();
    handleClose();
    } finally {
      setGuardando(false);
    }
  };
  // Estado y handlers para datos adicionales
  const [placaAdicional, setPlacaAdicional] = useState('');
  const [ordenCompraAdicional, setOrdenCompraAdicional] = useState('');
  const datosCargadosParaId = useRef(null);
  const [correlativoError,  setCorrelativoError]  = useState(null);
  const [fixingCorrelativo, setFixingCorrelativo] = useState(false);

  const handleFixCorrelativoNC = async () => {
    if (!correlativoError) return;
    setFixingCorrelativo(true);
    try {
      const r = await axios.put('/api/series/fix-correlativo', {
        tipo_documento: correlativoError.tipo_documento,
        serie: correlativoError.serie,
      });
      setForm(f => ({ ...f, numero: r.data.siguiente }));
      setSeries(prev => prev.map(s =>
        s.serie === correlativoError.serie ? { ...s, correlativo_actual: r.data.siguiente } : s
      ));
      setCorrelativoError(null);
    } catch (e) {
      alert('No se pudo regularizar la serie: ' + (e.response?.data?.error || e.message));
      setCorrelativoError(null);
    } finally {
      setFixingCorrelativo(false);
    }
  };

  // Ventana popup de datos adicionales
  const handleCloseDatosAdicionales = () => setOpenDatosAdicionales(false);

  const estadoVencimiento = (fecha_validez) => {
    if (!fecha_validez) return '';
    const hoy = new Date();
    const venc = new Date(fecha_validez);
    if (venc < hoy) return 'VENCIDA';
    if ((venc - hoy) / (1000 * 60 * 60 * 24) <= 3) return 'POR VENCER';
    return 'VIGENTE';
  };

  const getCpeStatusMeta = (estadoCpe) => {
    const color = {
      'PENDIENTE': 'info',
      'PROCESANDO': 'info',
      'PREPARADO': 'warning',
      'ENVIADO': 'warning',
      'ACEPTADO': 'success',
      'RECHAZADO': 'error',
      'ANULADO': 'error'
    }[estadoCpe] || 'default';

    const label = {
      'PENDIENTE': '⏳ Pendiente',
      'PROCESANDO': '⚙️ Procesando',
      'PREPARADO': '📋 Preparado',
      'ENVIADO': '📤 Enviado a SUNAT',
      'ACEPTADO': '✓ Aceptado',
      'RECHAZADO': '✗ Rechazado',
      'ANULADO': '🗑️ Anulado'
    }[estadoCpe] || estadoCpe;

    return { color, label };
  };

  const getAnulacionStatusMeta = (estadoAnulacion) => {
    const color = {
      'PENDIENTE': 'info',
      'PROCESANDO': 'warning',
      'PENDIENTE_SUNAT': 'warning',
      'ERROR_CONSULTA': 'warning',
      'ACEPTADA': 'success',
      'RECHAZADA': 'error',
      'ERROR_ENVIO': 'error'
    }[estadoAnulacion] || 'default';

    const label = {
      'PENDIENTE': 'anulación pendiente',
      'PROCESANDO': 'anulación procesando',
      'PENDIENTE_SUNAT': 'anulación en SUNAT',
      'ERROR_CONSULTA': 'Reintentando consulta',
      'ACEPTADA': 'anulación aceptada',
      'RECHAZADA': 'anulación rechazada',
      'ERROR_ENVIO': 'Error envío anulación'
    }[estadoAnulacion] || estadoAnulacion;

    return { color, label };
  };

  const renderEstadoBoleta = (nv) => {
    if (nv.estado === 'ANULADA' || nv.estado_registro === 0) {
      return (
        <Tooltip title="Anulada">
          <Chip icon={<Cancel color="error" />} label="Anulada" color="error" />
        </Tooltip>
      );
    }

    if (nv.estado_cpe) {
      const cpeMeta = getCpeStatusMeta(nv.estado_cpe);
      const anulacionMeta = nv.ultimo_estado_anulacion ? getAnulacionStatusMeta(nv.ultimo_estado_anulacion) : null;

      return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, alignItems: 'center' }}>
          <Tooltip title={`CPE: ${nv.estado_cpe}`}>
            <Chip
              label={cpeMeta.label}
              color={cpeMeta.color}
              variant="outlined"
              size="small"
              sx={{ fontWeight: 'bold' }}
            />
          </Tooltip>
          {anulacionMeta && (
            <Tooltip title={nv.ultimo_mensaje_anulacion || `anulación: ${nv.ultimo_estado_anulacion}`}>
              <Chip
                label={anulacionMeta.label}
                color={anulacionMeta.color}
                variant="filled"
                size="small"
                sx={{ fontWeight: 'bold' }}
              />
            </Tooltip>
          )}
        </Box>
      );
    }

    const estado = estadoVencimiento(nv.fecha_validez);
    if (estado === 'VENCIDA') {
      return (
        <Tooltip title="Vencida">
          <Chip icon={<Cancel color="error" />} label="Vencida" color="error" />
        </Tooltip>
      );
    }
    if (estado === 'POR VENCER') {
      return (
        <Tooltip title="Por vencer">
          <Chip icon={<Warning color="warning" />} label="Por vencer" color="warning" />
        </Tooltip>
      );
    }
    return (
      <Tooltip title="Vigente">
        <Chip icon={<CheckCircle color="success" />} label="Vigente" color="success" />
      </Tooltip>
    );
  };

  const actualizarResolucionFormato = async (nuevoFormato) => {
    setPdfResolucionCargando(true);
    try {
      const res = await axios.get(`/api/reporte-pdf/resuelve/${BoletaPdfTarget.id}`, { 
        params: { formato: nuevoFormato } 
      });
      setPdfResolucion(res.data || {});
    } catch (err) {
      console.error('Error updating PDF template resolution:', err);
    } finally {
      setPdfResolucionCargando(false);
    }
  };

  const abrirDialogoPdf = async (Boleta) => {
    const formatoGuardado = localStorage.getItem('nota_credito_pdf_formato_default') || 'A4';
    setBoletaPdfTarget(Boleta);
    setPdfFormatoSeleccionado(formatoGuardado);
    setGuardarPdfComoPredeterminado(true);
    setOpenPdfDialog(true);
    
    // Cargar resolución de plantilla
    setPdfResolucionCargando(true);
    try {
      const res = await axios.get(`/api/reporte-pdf/resuelve/${Boleta.id}`, { 
        params: { formato: formatoGuardado } 
      });
      setPdfResolucion(res.data || {});
    } catch (err) {
      console.error('Error resolving PDF template:', err);
      setPdfResolucion({});
    } finally {
      setPdfResolucionCargando(false);
    }
  };

  const cerrarDialogoPdf = () => {
    if (pdfDescargando) return;
    setOpenPdfDialog(false);
    setBoletaPdfTarget(null);
  };

  const descargarPdfBoleta = () => {
    if (!BoletaPdfTarget) return;

    const formato = String(pdfFormatoSeleccionado || 'A4').toUpperCase();
    if (guardarPdfComoPredeterminado) {
      localStorage.setItem('nota_credito_pdf_formato_default', formato);
    }
    const tk = localStorage.getItem('token') || '';
    const query = new URLSearchParams({ formato, mode: 'inline', _ts: Date.now() }).toString();
    window.open(`/api/reporte-pdf/comprobante/${BoletaPdfTarget.id}?${query}&token=${tk}`, '_blank');
    cerrarDialogoPdf();
  };

  // Búsqueda asíncrona de clientes en el Autocomplete
  useEffect(() => {
    if (open) {
      fetchClientesAsync(''); // cargar inicial
    }
  }, [open]);

  useEffect(() => {
    if (skipClienteSearch.current) { skipClienteSearch.current = false; return; }
    if (clienteInput !== '') {
      debouncedFetchClientes(clienteInput);
    } else if (open) {
      fetchClientesAsync('');
    }
  }, [clienteInput, open]);

  // Estados para Autocomplete vendedor
  const [vendedorInput, setVendedorInput] = useState('');
  const [loadingVendedores, setLoadingVendedores] = useState(false);

  // Búsqueda asíncrona de vendedores
  const fetchVendedoresAsync = async () => {
    setLoadingVendedores(true);
    if (usuarioLogueado) {
      // Mapear usuario logueado a la estructura esperada por el Autocomplete
      const vendedor = {
        id: usuarioLogueado.id,
        nombres: usuarioLogueado.nombres || usuarioLogueado.nombre || '',
        apellidos: usuarioLogueado.apellidos || '',
        username: usuarioLogueado.username || '',
        // ...otros campos si se requieren
      };
      console.log('Vendedor cargado:', vendedor);
      setVendedores([vendedor]);
      setForm(f => ({ ...f, vendedor_id: vendedor.id }));
    } else {
      setVendedores([]);
    }
    setLoadingVendedores(false);
  };

  const debouncedFetchVendedores = React.useMemo(() => debounce(fetchVendedoresAsync, 300), []);

  // Búsqueda asíncrona de vendedores en el Autocomplete
  useEffect(() => {
    if (open) {
      fetchVendedoresAsync(); // cargar inicial
    }
  }, [open]);

  // Al abrir el formulario, seleccionar por defecto Soles
  useEffect(() => {
    if (open) {
      fetchMonedasAsync('');
      setForm(f => ({ ...f, moneda: 'PEN' }));
    }
  }, [open]);


  // Boletas filtradas por búsqueda
  const filteredBoletas = Boletas.filter(nv => {
    const cliente = clientes.find(x => x.id === nv.cliente_id);
    const clienteStr = cliente ? `${cliente.razon_social || ''} ${cliente.numero_documento || ''}` : '';
    return (
      (nv.serie && nv.serie.toLowerCase().includes(search.toLowerCase())) ||
      (nv.numero && nv.numero.toString().includes(search)) ||
      clienteStr.toLowerCase().includes(search.toLowerCase()) ||
      (nv.total && nv.total.toString().includes(search)) ||
      (nv.fecha_emision && nv.fecha_emision.toString().includes(search))
    );
  })
  .sort((a, b) => {
    // Ordenar por fecha de emisión descendente y luego por id descendente
    const fechaA = new Date(a.fecha_emision).getTime() || 0;
    const fechaB = new Date(b.fecha_emision).getTime() || 0;
    if (fechaB !== fechaA) return fechaB - fechaA;
    return Number(b.id || 0) - Number(a.id || 0);
  });

  // Exportar a Excel
  const handleExportExcel = async () => {
    await exportComprobanteWorkbook({
      records: filteredBoletas,
      clientes,
      searchText: search,
      usuario: usuarioLogueado?.username || '',
      config: COMPROBANTE_CONFIG.NOTA_CREDITO
    });
  };

  // Paginado
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const handleChangePage = (newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };
  const paginatedBoletas = rowsPerPage === -1 ? filteredBoletas : filteredBoletas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // Almacenes disponibles según la sucursal seleccionada (igual que en Guía de Remisión):
  // se incluyen los de la sucursal elegida y los que no tienen sucursal asignada (compartidos)
  const almacenesDisponibles = almacenes.filter(a => {
    const activo = Number(a.estado ?? 1) === 1;
    if (!activo) return false;
    if (!form.sucursal_id) return true;
    if (a.sucursal_id == null) return true;
    return Number(a.sucursal_id) === Number(form.sucursal_id);
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1, mb: 4, width: '100%' }}>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 1800, mt: { xs: '0em', sm: '0em', md: '0em' } }}>
        <Typography variant="h4" gutterBottom sx={{ textAlign: { xs: 'center', md: 'left' }, mb: 3, fontWeight: 'bold', color: '#222' }}>Notas de Crédito</Typography>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
          <TextField
            placeholder="Buscar por serie, número o cliente..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            size="small"
            sx={{ flex: 1, minWidth: 220 }}
          />
          <Button
            variant="outlined"
            color="primary"
            startIcon={isRefreshingList ? <CircularProgress size={16} /> : <Refresh />}
            onClick={fetchBoletas}
            disabled={isRefreshingList}
            sx={{ minWidth: 170, borderRadius: 2 }}
          >
            {isRefreshingList ? 'Actualizando...' : 'Actualizar listado'}
          </Button>
          <Tooltip title="Refresca estados SUNAT sin perder filtros">
            <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary', px: 1 }}>
              <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
                Ult. actualización: {formatLastRefresh(lastRefreshAt)}
              </Typography>
            </Box>
          </Tooltip>
          <Button variant="contained" color="success" startIcon={<GridOn />} onClick={handleExportExcel} sx={{ minWidth: 150, display: { xs: 'none', sm: 'flex' } }}>
            Exportar Excel
          </Button>
          <Button variant="contained" color="primary" startIcon={<Add />} onClick={handleOpen} sx={{ minWidth: 120 }}>
            {isMobile ? 'Nueva' : 'Nueva Nota de Crédito'}
          </Button>
          <TextField
            size="small"
            label="Mostrar"
            type="number"
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
            sx={{ width: 100, display: { xs: 'none', sm: 'block' } }}
            inputProps={{ min: 1 }}
          />
        </Box>
        <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', mt: 2, overflowX: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">Serie</TableCell>
                <TableCell align="center">Número</TableCell>
                <TableCell align="center">Cliente</TableCell>
                <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Fecha Emisión</TableCell>
                <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Vence</TableCell>
                <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Estado</TableCell>
                <TableCell align="center">Total</TableCell>
                <TableCell align="center">Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedBoletas.map(nv => (
                <TableRow key={nv.id}>
                  <TableCell align="center">{nv.serie}</TableCell>
                  <TableCell align="center">
                    {nv.numero}
                    {(nv.referencia_comprobante || nv.origen_referencia) && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontSize: '0.68rem', lineHeight: 1.2 }}>
                        ↳ {nv.referencia_comprobante ? `Corrige ${nv.referencia_comprobante}` : nv.origen_referencia}
                      </Typography>
                    )}
                  </TableCell>
                  <TableCell align="center">{
                    (() => {
                      const cliente = clientes.find(x => x.id === nv.cliente_id);
                      if (cliente) {
                        const nombreCliente = cliente.razon_social || `${cliente.nombres || ''} ${cliente.apellidos || ''}`.trim();
                        return `${nombreCliente}${cliente.numero_documento ? ` (${cliente.numero_documento})` : ''}`;
                      } else if (nv.cliente_id) {
                        return `ID: ${nv.cliente_id}`;
                      } else {
                        return 'Sin cliente';
                      }
                    })()
                  }</TableCell>
                  <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{nv.fecha_emision?.substring(0, 10)}</TableCell>
                  <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{nv.fecha_validez?.substring(0, 10)}</TableCell>
                  <TableCell align="center" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{renderEstadoBoleta(nv)}</TableCell>
                  <TableCell align="center">{nv.total}</TableCell>
                  <TableCell align="center">
                    {/* Botones de acciones con colores y nuevas funciones */}
                    <Tooltip title={
                      nv.estado_cpe === 'ENVIADO' ? "No se puede editar: Comprobante enviado a SUNAT" :
                      nv.estado_cpe === 'RECHAZADO' ? "No se puede editar: Comprobante rechazado por SUNAT" :
                      nv.estado_cpe === 'ANULADO' ? "No se puede editar: Comprobante anulado" :
                      "Editar"
                    }>
                      <IconButton color="primary" onClick={async () => {
                        try {
                          const res = await axios.get(`/api/comprobante/${nv.id}`);
                          const nov = res.data;
                          setModoEdicion(true);
                          setOpen(true);
                          setForm(prev => ({
                            ...prev,
                            ...nov,
                            detalles: Array.isArray(nov.detalles) ? nov.detalles : (typeof nov.detalles === 'string' && nov.detalles && nov.detalles.trim().startsWith('[') ? JSON.parse(nov.detalles) : []),
                            fecha_emision: nov.fecha_emision ? nov.fecha_emision.substring(0, 10) : '',
                            fecha_validez: nov.fecha_validez ? nov.fecha_validez.substring(0, 10) : '',
                            adjuntos: Array.isArray(nov.adjuntos) ? nov.adjuntos : (typeof nov.adjuntos === 'string' && nov.adjuntos && nov.adjuntos.trim().startsWith('[') ? JSON.parse(nov.adjuntos) : []),
                            serie: nov.serie,
                            numero: nv.numero, // Forzar el correlativo de la lista seleccionada
                            cliente_id: nov.cliente_id,
                            vendedor_id: nov.vendedor_id,
                            moneda: nov.moneda,
                            tipo_cambio: nov.tipo_cambio,
                            condicion_pago: nov.condicion_pago_id || nov.condicion_pago,
                            cuotas_json: nov.cuotas_json,
                            subtotal: nov.subtotal,
                            descuento_global: nov.descuento_global,
                            porcentaje_descuento_global: nov.porcentaje_descuento_global,
                            total_igv: nov.total_igv,
                            total: nov.total,
                            observaciones: nov.observaciones,
                            estado: nov.estado,
                            sucursal_id: nov.sucursal_id,
                            detraccion_porcentaje_personalizado: false,
                            detraccion_porcentaje: 12
                          }));
                          // Si la detracción usó un % personalizado, recuperarlo (guardado aparte,
                          // no viaja en el objeto del comprobante)
                          if (nov.detraccion_aplicada) {
                            try {
                              const resPct = await axios.get(`/api/datos-adicionales/NOTA_CREDITO/${nov.id}/detraccion_porcentaje`);
                              const pctGuardado = resPct?.data?.valor;
                              if (pctGuardado) {
                                setForm(f => ({ ...f, detraccion_porcentaje_personalizado: true, detraccion_porcentaje: Number(pctGuardado) }));
                              }
                            } catch { /* sin % guardado, se deja el modo manual actual */ }
                          }
                          // Manejar el check de preciosIncluyenIgv
                          if (nov.hasOwnProperty('preciosIncluyenIgv')) {
                            setPreciosIncluyenIgv(!!nov.preciosIncluyenIgv);
                          } else if (nov.hasOwnProperty('precios_incluyen_igv')) {
                            setPreciosIncluyenIgv(nov.precios_incluyen_igv === 1 || nov.precios_incluyen_igv === true);
                          } else {
                            // Si no viene en la cotización, usar config empresa
                            try {
                              const { obtenerEmpresaConfig } = await import('../utils/empresaConfig');
                              const config = await obtenerEmpresaConfig();
                              if (config && (config.precios_incluyen_igv === 1 || config.precios_incluyen_igv === true)) {
                                setPreciosIncluyenIgv(true);
                              } else {
                                setPreciosIncluyenIgv(false);
                              }
                            } catch (err) {
                              setPreciosIncluyenIgv(false);
                            }
                          }
                          // Restaurar referencia: manual o del sistema
                          setRefManualMode(false);
                          setRefManualSerie('');
                          setRefManualNumero('');
                          setRefManualTipo('01');
                          setReferenciaNcLabel('');
                          setReferenciaNcSnapshot(null);
                          try {
                            const refManRes = await axios.get(`/api/datos-adicionales/NOTA_CREDITO/${nov.id}/ref_manual`);
                            const refManVal = refManRes.data?.valor || '';
                            if (refManVal) {
                              const parts = refManVal.split('|');
                              setRefManualMode(true);
                              setRefManualSerie(parts[0] || '');
                              setRefManualNumero(parts[1] || '');
                              setRefManualTipo(parts[2] || '01');
                              setReferenciaNcLabel(`${parts[0] || ''}-${String(parts[1] || '0').padStart(8, '0')}`);
                            } else if (nov.comprobante_referencia_id) {
                              const refRes = await axios.get(`/api/comprobante/${nov.comprobante_referencia_id}`);
                              const refDoc = refRes.data;
                              setReferenciaNcLabel(`${refDoc.serie}-${String(refDoc.numero).padStart(8, '0')}`);
                              setReferenciaNcSnapshot({ referenciaId: nov.comprobante_referencia_id, detalles: [] });
                            }
                          } catch (_) {}
                        } catch (err) {
                          alert('Error al obtener detalles de la Nota de Crédito.');
                        }
                      }}
                      disabled={nv.estado === 'ANULADA' || nv.estado_registro === 0 || nv.estado_cpe === 'ENVIADO' || nv.estado_cpe === 'RECHAZADO' || nv.estado_cpe === 'ANULADO'}
                      >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Anular Electrónicamente">
                    <IconButton color="error" onClick={() => {
                      setBoletaAAnular(nv);
                      setMotivoAnulacion('');
                      setProcesandoAnulacion(false);
                      setOpenAnulacion(true);
                    }}
                    disabled={nv.estado === 'ANULADA' || nv.estado_registro === 0 || !['ACEPTADO', 'ENVIADO'].includes(nv.estado_cpe) || ['PENDIENTE', 'PROCESANDO', 'PENDIENTE_SUNAT', 'PENDIENTE_RESUMEN', 'PENDIENTE_SUNAT_RESUMEN', 'PROCESANDO_RESUMEN', 'ERROR_CONSULTA'].includes(nv.ultimo_estado_anulacion)}
                    >
                    <Gavel />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Ver">
                    <IconButton color="success" onClick={async () => {
                      try {
                        const res = await axios.get(`/api/comprobante/${nv.id}`);
                        const nota = res.data;
                        // Parsear detalles y adjuntos si vienen como string
                        let detalles = Array.isArray(nota.detalles) ? nota.detalles : (typeof nota.detalles === 'string' && nota.detalles ? JSON.parse(nota.detalles) : []);
                        let adjuntos_json = Array.isArray(nota.adjuntos_json) ? nota.adjuntos_json : (typeof nota.adjuntos_json === 'string' && nota.adjuntos_json ? JSON.parse(nota.adjuntos_json) : []);
                        let estadoVisual = estadoVencimiento(nota.fecha_validez);
                        if (!nota.fecha_validez) {
                          estadoVisual = 'VIGENTE';
                        }
                        setVerBoleta({ ...nota, detalles, adjuntos_json, estadoVisual });
                      } catch (err) {
                        alert('Error al obtener detalles de la Nota de Crédito.');
                      }
                    }}>
                      <CheckCircle />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="PDF">
                    <IconButton color="secondary" onClick={async () => {
                      abrirDialogoPdf(nv);
                    }}>
                      <CloudUpload />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Descargar XML">
                    <span>
                      <IconButton
                        color="info"
                        disabled={!(findAdjuntoByTipo(nv.adjuntos_json, 'xml') || nv.xml_firmado_path)}
                        onClick={(e) => {
                          e.stopPropagation();
                          const nombre = findAdjuntoByTipo(nv.adjuntos_json, 'xml');
                          const tk = localStorage.getItem('token') || '';
                          if (nombre) {
                            window.open(`/api/comprobante/adjunto/${nv.serie}/${nv.numero}/${nombre}?token=${tk}`, '_blank');
                            return;
                          }
                          window.open(`/api/comprobante/${nv.id}/archivo-cpe/xml?token=${tk}`, '_blank');
                        }}
                      >
                        <Description />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title="Descargar CDR">
                    <span>
                      <IconButton
                        color="success"
                        disabled={!(findAdjuntoByTipo(nv.adjuntos_json, 'cdr') || nv.cdr_path)}
                        onClick={(e) => {
                          e.stopPropagation();
                          const nombre = findAdjuntoByTipo(nv.adjuntos_json, 'cdr');
                          const tk = localStorage.getItem('token') || '';
                          if (nombre) {
                            window.open(`/api/comprobante/adjunto/${nv.serie}/${nv.numero}/${nombre}?token=${tk}`, '_blank');
                            return;
                          }
                          window.open(`/api/comprobante/${nv.id}/archivo-cpe/cdr?token=${tk}`, '_blank');
                        }}
                      >
                        <Archive />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip
                    title={
                      puedeReenviarCpe(nv)
                        ? 'Reenviar CPE a SUNAT'
                        : 'No disponible: si fue rechazado o anulado, emita un comprobante nuevo'
                    }
                  >
                    <span>
                      <IconButton
                        color="warning"
                        disabled={!puedeReenviarCpe(nv) || reenviandoCpeId === nv.id}
                        onClick={() => reenviarCpe(nv)}
                      >
                        {reenviandoCpeId === nv.id ? <CircularProgress size={18} /> : <Refresh />}
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title="Enviar por WhatsApp">
                    <IconButton size="small" sx={{ color: '#25d366' }}
                      onClick={() => setWspDialog({ open: true, data: nv })}>
                      <WhatsAppIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                        {/* Modal para ver Boleta */}
                        {verBoleta && (
                          <Dialog open={true} onClose={() => setVerBoleta(null)} maxWidth="md" fullWidth>
                            <DialogTitle sx={{ bgcolor: '#1976d2', color: '#fff', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}>
                              <Receipt /> Detalle de Nota de Crédito
                            </DialogTitle>
                            <DialogContent sx={{ bgcolor: '#fafbfc', pt: '20px !important' }}>
                              <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
                                <Typography variant="h6" fontWeight="bold" color="#1976d2" gutterBottom>
                                  {clientes.find(x => x.id === verBoleta.cliente_id)?.razon_social || ''}
                                </Typography>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 1 }}>
                                  <Typography variant="body2"><strong>Serie-Número:</strong> {verBoleta.serie}-{verBoleta.numero}</Typography>
                                  <Typography variant="body2"><strong>Fecha Emisión:</strong> {verBoleta.fecha_emision?.substring(0, 10) || ''}</Typography>
                                  <Typography variant="body2"><strong>Moneda:</strong> {verBoleta.moneda}</Typography>
                                  <Typography variant="body2"><strong>Condición Pago:</strong> {verBoleta.condicion_pago || ''}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Typography variant="body2" fontWeight="bold">Estado:</Typography>
                                  <Chip size="small" variant="outlined" color="info" label={
                                    verBoleta.estado === 'PENDIENTE'
                                      ? (verBoleta.estadoVisual || verBoleta.estado)
                                      : verBoleta.estado
                                  } />
                                </Box>
                                {verBoleta.observaciones && (
                                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                    <strong>Observaciones:</strong> {verBoleta.observaciones}
                                  </Typography>
                                )}
                              </Paper>
                              <TableContainer component={Paper} variant="outlined">
                                <Table size="small">
                                  <TableHead>
                                    <TableRow sx={{ bgcolor: '#1976d2' }}>
                                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Código</TableCell>
                                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Producto</TableCell>
                                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Almacén</TableCell>
                                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Cantidad</TableCell>
                                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>U.Medida</TableCell>
                                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Precio</TableCell>
                                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Subtotal</TableCell>
                                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>IGV</TableCell>
                                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Total</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {(Array.isArray(verBoleta.detalles) ? verBoleta.detalles : (typeof verBoleta.detalles === 'string' && verBoleta.detalles && verBoleta.detalles.trim().startsWith('[') ? JSON.parse(verBoleta.detalles) : [])).map((d, idx) => (
                                      <TableRow key={idx} sx={{ backgroundColor: idx % 2 === 0 ? '#f5f5f5' : '#fff' }}>
                                        <TableCell>{d.codigo_producto || productos.find(p => p.id === d.producto_id)?.codigo || ''}</TableCell>
                                        <TableCell>{d.descripcion_producto || productos.find(p => p.id === d.producto_id)?.nombre || ''}</TableCell>
                                        <TableCell>{almacenes.find(a => Number(a.id) === Number(d.almacen_id))?.nombre || ''}</TableCell>
                                        <TableCell>{d.cantidad}</TableCell>
                                        <TableCell>{d.unidad_medida}</TableCell>
                                        <TableCell>{d.precio_unitario}</TableCell>
                                        <TableCell>{d.subtotal}</TableCell>
                                        <TableCell>{d.igv_monto}</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>{d.total}</TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              {/* Adjuntos */}
                              {verBoleta.adjuntos_json && typeof verBoleta.adjuntos_json === 'string' && verBoleta.adjuntos_json.trim().startsWith('[') && JSON.parse(verBoleta.adjuntos_json).length > 0 && (
                                <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
                                  <Typography variant="subtitle1" fontWeight="bold" color="#1976d2" gutterBottom>Documentos Adjuntos</Typography>
                                  {JSON.parse(verBoleta.adjuntos_json).map((nombre, idx) => (
                                    <Button key={idx} variant="outlined" color="info" startIcon={getAdjuntoStartIcon(nombre)} onClick={() => {
                                      // Descarga directa desde la ruta correcta
                                      const link = document.createElement('a');
                                      link.href = `/api/comprobante/adjunto/${verBoleta.serie}/${verBoleta.numero}/${nombre}?token=${localStorage.getItem('token') || ''}`;
                                      link.target = '_blank';
                                      link.download = nombre;
                                      document.body.appendChild(link);
                                      link.click();
                                      document.body.removeChild(link);
                                    }} sx={{ mr: 1, mb: 1 }}>
                                      {nombre}
                                    </Button>
                                  ))}
                                </Paper>
                              )}
                            </DialogContent>
                            <DialogActions sx={{ p: 2 }}>
                              <Button onClick={() => setVerBoleta(null)} startIcon={<Cancel />} variant="outlined">Cerrar</Button>
                            </DialogActions>
                          </Dialog>
                        )}
                  {/* Botón para descargar/ver adjuntos */}
                  {nv.adjuntos_json && JSON.parse(nv.adjuntos_json).length > 0 && (
                    <Tooltip title="Descargar adjuntos">
                      <IconButton color="info" onClick={e => {
                        e.stopPropagation();
                        const tk = localStorage.getItem('token') || '';
                        JSON.parse(nv.adjuntos_json).forEach((nombre, i) => {
                          setTimeout(() => {
                            const a = document.createElement('a');
                            a.href = `/api/comprobante/adjunto/${nv.serie}/${nv.numero}/${nombre}?token=${tk}`;
                            a.download = nombre;
                            document.body.appendChild(a); a.click(); document.body.removeChild(a);
                          }, i * 500);
                        });
                      }}>
                        <AttachFile />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginacionControl page={page} rowsPerPage={rowsPerPage} count={filteredBoletas.length} onPageChange={handleChangePage} />
      <Dialog open={open} onClose={(_, r) => r !== 'backdropClick' && handleClose()} disableEscapeKeyDown={false} maxWidth="lg" fullWidth fullScreen={isMobile}>
        <DialogTitle sx={{ bgcolor: '#1976d2', color: '#fff', fontWeight: 'bold', fontSize: { xs: 17, sm: 22 }, letterSpacing: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Receipt sx={{ mr: 1, mb: -0.5 }} /> {modoEdicion ? 'Editar Nota de Crédito' : 'Nueva Nota de Crédito'}
          </Box>
          {isMobile && (<IconButton size="small" onClick={handleClose} sx={{ color: '#fff' }}><Close /></IconButton>)}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 2 }} justifyContent={'center'}>
            <Grid item xs={4} sx={{ width: { xs: '100%', sm: '30em' }, minWidth: { xs: 0, sm: '30em' } }}>
              <Autocomplete
                options={sucursales}
                getOptionLabel={option => option.nombre ? `${option.nombre}` : ''}
                value={sucursales.find(s => s.id === form.sucursal_id) || null}
                inputValue={sucursalInput}
                onInputChange={(e, value) => setSucursalInput(value)}
                onChange={(e, value) => { if (value) setForm(f => ({ ...f, sucursal_id: value.id })); }}
                loading={loadingSucursales}
                disabled={ncBloquearCabeceraGeneral}
                disableClearable
                renderInput={params => (
                  <TextField {...params} label="Sucursal" fullWidth required InputProps={{ ...params.InputProps, endAdornment: (<>{params.InputProps.endAdornment}</>) }} />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField type="date" label="Emisión" name="fecha_emision" value={form.fecha_emision} onChange={handleFechaEmisionChange} fullWidth InputLabelProps={{ shrink: true }} disabled={ncBloquearCabeceraGeneral} />
            </Grid>
            <Grid item xs={3}>
              <TextField type="date" label="Vence" name="fecha_validez" value={form.fecha_validez} onChange={handleFormChange} fullWidth InputLabelProps={{ shrink: true }} disabled={ncBloquearCabeceraGeneral} />
            </Grid>
            <Grid item xs={2} sx={{ width: '8em', minWidth: '8em', flexBasis: '8em !important', maxWidth: 'none !important' }}>
              <Autocomplete
                options={series}
                getOptionLabel={option => option.serie ? `${option.serie}` : ''}
                value={series.find(s => s.serie === form.serie) || null}
                inputValue={serieInput}
                onInputChange={(e, value) => setSerieInput(value)}
                onChange={(e, value) => {
                  setForm(f => ({ ...f, serie: value ? value.serie : '' }));
                  if (!modoEdicion) {
                    setForm(f => ({ ...f, numero: value ? value.correlativo_actual : '' }));
                  }
                }}
                loading={loadingSeries}
                disabled={ncBloquearCabeceraGeneral}
                disableClearable
                renderInput={params => (
                  <TextField {...params} label="Serie" fullWidth required InputProps={{ ...params.InputProps, endAdornment: (<>{params.InputProps.endAdornment}</>) }} />
                )}
              />
            </Grid>
            <Grid item xs={2} sx={{ width: '8em', minWidth: '8em', flexBasis: '8em !important', maxWidth: 'none !important' }}>
              <TextField label="Número" name="numero" value={form.numero} fullWidth required disabled />
            </Grid>
            <Grid item xs={4} sx={{ width: { xs: '100%', sm: '30em' }, minWidth: { xs: 0, sm: '30em' } }}>
              <Autocomplete
                options={clientes}
                getOptionLabel={option => {
                  const nombreCliente = option.razon_social || `${option.nombres || ''} ${option.apellidos || ''}`.trim();
                  return nombreCliente && option.numero_documento ? `${nombreCliente} (${option.numero_documento})` : nombreCliente;
                }}
                value={clientes.find(c => c.id === form.cliente_id) || null}
                inputValue={clienteInput}
                onInputChange={(e, value) => setClienteInput(value)}
                noOptionsText={clienteInput.length >= 2 ? (<Button size="small" onMouseDown={(e) => e.preventDefault()} onClick={() => setOpenNuevoCliente(true)}>+ Registrar "{clienteInput}" como nuevo cliente</Button>) : 'Escribe para buscar'}
                onChange={(e, value) => setForm({ ...form, cliente_id: value ? value.id : '' })}
                loading={loadingClientes}
                disabled={ncBloquearCabeceraGeneral}
                renderInput={params => (
                  <TextField {...params} label="Cliente" fullWidth required InputProps={{ ...params.InputProps, endAdornment: (<>{params.InputProps.endAdornment}</>) }} />
                )}
              />
            </Grid>
            <Grid item xs={2}  sx={{ width: '13em', minWidth: '13em' }}>
              <Autocomplete
                options={monedas}
                getOptionLabel={option => option.descripcion && option.codigo ? `${option.descripcion} (${option.codigo})` : option.descripcion || ''}
                value={monedas.find(m => m.codigo === form.moneda) || null}
                inputValue={monedaInput}
                onInputChange={(e, value) => setMonedaInput(value)}
                onChange={async (e, value) => {
                  const nuevaMoneda = value ? value.codigo : '';
                  setForm(f => ({ ...f, moneda: nuevaMoneda }));
                  if (nuevaMoneda === 'USD') {
                    const fecha = form.fecha_emision;
                    try {
                      // 1. Buscar en la BD
                      const resBD = await axios.get('/api/tipo-cambio');
                      const tc = resBD.data.find(x => x.fecha && x.fecha.substring(0,10) === fecha);
                      if (tc && tc.venta) {
                        setForm(f => ({ ...f, tipo_cambio: tc.venta }));
                        return;
                      }
                    } catch {}
                    try {
                      // 2. Si no existe en BD, buscar en API
                      const res = await axios.get(`/api/tipo-cambio/sunat?fecha=${fecha}`);
                      if (res.data && res.data.venta) {
                        setForm(f => ({ ...f, tipo_cambio: res.data.venta }));
                        return;
                      }
                    } catch {}
                    // 3. Si falla todo, poner 1
                    setForm(f => ({ ...f, tipo_cambio: 1 }));
                  } else {
                    setForm(f => ({ ...f, tipo_cambio: 1 }));
                  }
                }}
                loading={loadingMonedas}
                disabled={ncBloquearCabeceraGeneral}
                disableClearable
                renderInput={params => (
                  <TextField {...params} label="Moneda" fullWidth required InputProps={{ ...params.InputProps, endAdornment: (<>{params.InputProps.endAdornment}</>) }} />
                )}
              />
            </Grid>
            <Grid item xs={2} sx={{ width: '8em', minWidth: '8em' }}>
              <TextField label="Tipo Cambio" name="tipo_cambio" value={form.tipo_cambio} onChange={handleFormChange} fullWidth disabled={ncBloquearCabeceraGeneral} />
            </Grid>
            <Grid item xs={2} sx={{ width: { xs: '100%', sm: '15.6em' }, minWidth: { xs: 0, sm: '15.6em' } }}>
              <Autocomplete
                options={vendedores}
                getOptionLabel={option => option.nombres && option.apellidos && option.username ? `${option.nombres} ${option.apellidos} (${option.username})` : option.nombres || ''}
                value={vendedores.find(v => v.id === form.vendedor_id) || null}
                inputValue={vendedores.find(v => v.id === form.vendedor_id) ? `${vendedores.find(v => v.id === form.vendedor_id).nombres} ${vendedores.find(v => v.id === form.vendedor_id).apellidos} (${vendedores.find(v => v.id === form.vendedor_id).username})` : ''}
                disabled
                renderInput={params => (
                  <TextField {...params} label="Vendedor" fullWidth required disabled />
                )}
              />
            </Grid>
            <Grid item xs={4} sx={{ width: { xs: '100%', sm: '18em' }, minWidth: { xs: 0, sm: '18em' } }}>
              <Autocomplete
                options={condicionesPago}
                getOptionLabel={option => option?.descripcion || ''}
                value={condicionesPago.find(c => c.id === form.condicion_pago) || null}
                onChange={(e, value) => setForm(f => ({ ...f, condicion_pago: value ? value.id : '' }))}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                loading={loadingCondicionesPago}
                disabled={ncBloquearCabeceraGeneral}
                disableClearable
                renderInput={params => (
                  <TextField {...params} label="Condición Pago" fullWidth />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={8} sx={{ minWidth: { xs: 0, sm: '27em' } }}>
                  <TextField label="Observaciones" name="observaciones" value={form.observaciones} onChange={handleFormChange} fullWidth disabled={ncBloquearCabeceraGeneral} />
                </Grid>
                <Grid item xs={2}>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<AddCircleIcon />}
                    fullWidth
                    sx={{ backgroundColor: '#f3e5f5', color: '#7b1fa2', fontWeight: 'bold' }}
                    onClick={handleOpenDatosAdicionales} // función para abrir el diálogo de datos adicionales
                    disabled={ncBloquearCabeceraGeneral}
                  >
                    Datos adicionales
                  </Button>
                </Grid>
                <Grid item xs={2}>
                  <Button
                    variant="contained"
                    color="info"
                    component="label"
                    startIcon={<AttachFile />}
                    fullWidth
                    sx={{ backgroundColor: '#e3f2fd', color: '#1976d2', fontWeight: 'bold' }}
                    disabled={ncBloquearCabeceraGeneral}
                  >
                    Adjuntar
                    <input type="file" hidden multiple onChange={handleAdjunto} />
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={4} sx={{ minWidth: refManualMode ? '19.5em' : '23.5em', width: refManualMode ? '19.5em' : '23.5em' }}>
              <Autocomplete
                options={tiposNotaCredito}
                getOptionLabel={option => option ? `${option.codigo} - ${option.descripcion}` : ''}
                value={tiposNotaCredito.find(t => t.codigo === form.tipo_nota_credito) || null}
                onChange={(e, value) => {
                  const descripcion = value ? String(value.descripcion || '') : '';
                  setForm(f => ({
                    ...f,
                    tipo_nota_credito: value ? value.codigo : '',
                    motivo_nota: descripcion
                  }));
                }}
                isOptionEqualToValue={(option, value) => option.codigo === value.codigo}
                renderInput={params => (
                  <TextField {...params} label="Tipo Nota Crédito" fullWidth required />
                )}
              />
            </Grid>
            {refManualMode ? (
              <>
                <Grid item sx={{ minWidth: '10em', width: '10em' }}>
                  <TextField
                    select
                    label="Tipo doc."
                    value={String(form.serie || '').toUpperCase().startsWith('B') ? '03' : '01'}
                    disabled
                    fullWidth
                    size="small"
                  >
                    <MenuItem value="01">01 - Factura</MenuItem>
                    <MenuItem value="03">03 - Boleta</MenuItem>
                    <MenuItem value="07">07 - Nota Crédito</MenuItem>
                    <MenuItem value="08">08 - Nota Débito</MenuItem>
                  </TextField>
                </Grid>
                <Grid item sx={{ minWidth: '7em', width: '7em' }}>
                  <TextField
                    label="Serie"
                    value={refManualSerie}
                    onChange={e => {
                      const val = e.target.value.toUpperCase();
                      setRefManualSerie(val);
                      setReferenciaNcLabel(`${val}-${String(refManualNumero).padStart(8, '0')}`);
                    }}
                    fullWidth
                    size="small"
                    placeholder="F001"
                    inputProps={{ maxLength: 10 }}
                  />
                </Grid>
                <Grid item sx={{ minWidth: '8em', width: '8em' }}>
                  <TextField
                    label="Número"
                    value={refManualNumero}
                    onChange={e => {
                      const val = e.target.value.replace(/\D/g, '');
                      setRefManualNumero(val);
                      setReferenciaNcLabel(`${refManualSerie}-${String(val).padStart(8, '0')}`);
                    }}
                    fullWidth
                    size="small"
                    placeholder="21905"
                    inputProps={{ maxLength: 8 }}
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={2} sx={{ minWidth: '11em', width: '11em' }}>
                  <TextField
                    label="Comprobante Referencia"
                    value={referenciaNcLabel}
                    fullWidth
                    required
                    InputProps={{ readOnly: true }}
                    placeholder="Selecciona factura o boleta"
                  />
                </Grid>
                <Grid item xs={2} sx={{ minWidth: '9em', width: '9em' }}>
                  <Button variant="contained" color="warning" fullWidth onClick={() => setOpenReferenciaNc(true)}>
                    REFERENCIA
                  </Button>
                </Grid>
              </>
            )}
            <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
              <Tooltip title="Referencia Manual">
                <Switch
                  checked={refManualMode}
                  onChange={e => {
                    setRefManualMode(e.target.checked);
                    if (!e.target.checked) {
                      setRefManualSerie('');
                      setRefManualNumero('');
                      setRefManualTipo('01');
                      setReferenciaNcLabel('');
                      setForm(f => ({ ...f, comprobante_referencia_id: '' }));
                    }
                  }}
                  size="small"
                  color="warning"
                />
              </Tooltip>
            </Grid>
            <Grid item xs={4} sx={{ minWidth: refManualMode ? '17em' : '20em', width: refManualMode ? '17em' : '20em' }}>
              <TextField
                label="Motivo Nota"
                name="motivo_nota"
                value={form.motivo_nota || ''}
                onChange={handleFormChange}
                fullWidth
                required
                disabled={false}
              />
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h6" sx={{ color: '#000000', fontWeight: 'bold' }}>Detalle de productos</Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={preciosIncluyenIgv}
                      onChange={e => setPreciosIncluyenIgv(e.target.checked)}
                      color="primary"
                      disabled={ncBloquearAgregarDetalle}
                    />
                  }
                  label="Precios incluyen IGV"
                  sx={{ ml: 2 }}
                />
              </Box>
              <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                <Table size="small" sx={{ minWidth: 680 }}>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#2e8ae6' }}>
                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Producto</TableCell>
                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Cant.</TableCell>
                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>U.Medida</TableCell>
                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Precio</TableCell>
                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Dscto</TableCell>
                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Subtotal</TableCell>
                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>IGV</TableCell>
                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Total</TableCell>
                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Almacén</TableCell>
                      <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {form.detalles.map((d, idx) => (
                      <TableRow
                        key={idx}
                        sx={{
                          backgroundColor: idx % 2 === 0 ? '#f5f5f5' : '#fff'
                        }}
                      >
                        <TableCell
                          sx={{
                            maxWidth: 140,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            WebkitLineClamp: 1,
                          }}
                        >
                          <Tooltip title={d.descripcion_producto || productos.find(p => p.id === d.producto_id)?.nombre || ''}>
                            <span style={{ display: 'inline-block', maxWidth: '100%', verticalAlign: 'middle', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {d.descripcion_producto || productos.find(p => p.id === d.producto_id)?.nombre || ''}
                            </span>
                          </Tooltip>
                        </TableCell>
                        <TableCell>{d.cantidad}</TableCell>
                        <TableCell>{unidades.find(u => u.id === d.unidad_medida)?.abreviatura || d.unidad_medida}</TableCell>
                        <TableCell>{d.precio_unitario}</TableCell>
                        <TableCell>{d.descuento_monto || d.descuento_porcentaje}</TableCell>
                        <TableCell>{d.subtotal}</TableCell>
                        <TableCell>{d.igv_monto}</TableCell>
                        <TableCell>{d.total}</TableCell>
                        <TableCell>{almacenes.find(a => Number(a.id) === Number(d.almacen_id))?.nombre || ''}</TableCell>
                        <TableCell>
                          <Tooltip title={
                            ncGrupoCopiaExacta ? 'Bloqueado: anulación/devolución total requiere copia exacta (tipos 01/02/06)' :
                            ncTipo03Correccion ? 'Editar descripción del ítem (tipo 03)' :
                            ncTipo07DevolucionItem ? 'Editar descripción o cantidad devuelta (tipo 07)' :
                            ncGrupoPrecioAjuste ? 'Editar precio/descuento (tipos 04/05/09)' :
                            ncGrupoLibre ? 'Editar ítem (tipos 08/10)' : 'Editar'
                          }><span><IconButton color="primary" onClick={() => editarDetalle(idx)} disabled={ncGrupoCopiaExacta}><Edit /></IconButton></span></Tooltip>
                          <Tooltip title={ncBloquearEliminarDetalle ? 'Bloqueado: este tipo de NC no permite eliminar ítems' : 'Eliminar ítem (solo devueltos)'}><span><IconButton color="error" onClick={() => eliminarDetalle(idx)} disabled={ncBloquearEliminarDetalle}><Delete /></IconButton></span></Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 0.5 }}>
                <FormControlLabel
                  control={<Checkbox checked={copiarNombreADesc} onChange={e => setCopiarNombreADesc(e.target.checked)} color="secondary" size="small" />}
                  label={<Typography variant="caption">Copiar nombre → descripción</Typography>}
                />
              </Box>
              <Grid container spacing={1} alignItems="center" justifyContent={'center'}>
                <Grid item xs={4} sx={{ width: { xs: '100%', sm: '20em' }, minWidth: { xs: 0, sm: '20em' } }}>
                  <Autocomplete
                    options={productos}
                    getOptionLabel={option => option?.nombre || ''}
                    renderOption={(props, option) => (
                      <li {...props}>
                        {option.codigo && (
                          <Box component="span" sx={{ color: 'text.secondary', fontSize: '0.78em', mr: 1, minWidth: '4.5em', flexShrink: 0 }}>
                            {option.codigo}
                          </Box>
                        )}
                        {option.nombre}
                      </li>
                    )}
                    filterOptions={(options, { inputValue }) => {
                      if (!inputValue) return options;
                      const v = inputValue.toLowerCase();
                      const filtered = options.filter(o =>
                        (o.nombre || '').toLowerCase().includes(v) ||
                        (o.codigo || '').toLowerCase().includes(v)
                      );
                      const selId = detalle.producto_id;
                      if (selId && !filtered.some(o => o.id === selId)) {
                        const sel = options.find(o => o.id === selId);
                        if (sel) return [sel, ...filtered];
                      }
                      return filtered;
                    }}
                    value={productos.find(p => p.id === detalle.producto_id) || null}
                    inputValue={productoInput}
                    onInputChange={(e, value, reason) => {
                      if (reason === 'input') {
                        setProductoInput(value);
                        debouncedFetchProductos(value);
                      } else if (reason === 'clear') {
                        setProductoInput('');
                        debouncedFetchProductos('');
                      }
                    }}
                    noOptionsText={productoInput.length >= 2 ? (<Button size="small" onMouseDown={(e) => e.preventDefault()} onClick={() => setOpenNuevoProducto(true)}>+ Registrar "{productoInput}" como nuevo producto</Button>) : 'Escribe para buscar'}
                    onChange={(e, value) => {
                      handleDetalleChange({ target: { name: 'producto_id', value: value ? value.id : '' } });
                      setProductoInput(value ? (value.nombre || '') : '');
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    disabled={ncBloquearAgregarDetalle || (ncSoloDescripcionDetalle && editingDetalle !== null)}
                    renderInput={params => (
                      <TextField {...params} label="Producto" fullWidth error={detalleError.producto} />
                    )}
                  />
                </Grid>
                <Grid item xs={4} sx={{ width: { xs: '100%', sm: '21em' }, minWidth: { xs: 0, sm: '21em' } }}>
                  <TextField label="Descripción de producto" name="descripcion_producto" value={detalle.descripcion_producto} onChange={handleDetalleChange} fullWidth disabled={ncGrupoCopiaExacta}
                    onKeyDown={e => { if (e.key === 'F1') { e.preventDefault(); setOpenBuscadorProducto(true); } }}
                    InputProps={{
                      endAdornment: (
                        <Tooltip title="Buscar producto (F1)">
                          <IconButton size="small" onClick={() => setOpenBuscadorProducto(true)} edge="end">
                            <SearchIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={1} sx={{ width: '6.5em', minWidth: '6.5em' }}>
                  <TextField label="Cant." name="cantidad" value={detalle.cantidad} onChange={handleDetalleChange} fullWidth error={detalleError.cantidad} disabled={ncBloquearAgregarDetalle} />
                </Grid>
                <Grid item xs={1} sx={{ width: '6.5em', minWidth: '6.5em' }}>
                  <TextField label="Precio" name="precio_unitario" value={detalle.precio_unitario} onChange={handleDetalleChange} fullWidth disabled={ncBloquearAgregarDetalle} />
                </Grid>
                <Grid item xs={1} sx={{ width: '6.5em', minWidth: '6.5em' }}>
                  <TextField label="Desc. S/" name="descuento_monto" value={detalle.descuento_monto} onChange={handleDetalleChange} fullWidth disabled={ncBloquearAgregarDetalle} />
                </Grid>
                <Grid item xs={1} sx={{ width: '6.5em', minWidth: '6.5em' }}>
                  <TextField label="Desc. %" name="descuento_porcentaje" value={detalle.descuento_porcentaje} onChange={handleDetalleChange} fullWidth disabled={ncBloquearAgregarDetalle} />
                </Grid>
                {isMobile && <div style={{ flexBasis: '100%', width: '100%', height: 0 }} />}
                <Grid item xs={4} sx={{ width: { xs: '100%', sm: '24em' }, minWidth: { xs: 0, sm: '24em' }, mt: { xs: 0, sm: 1 } }}>
                  <Autocomplete
                    options={Array.isArray(tiposIGV) ? tiposIGV : []}
                    getOptionLabel={option => option?.descripcion || ''}
                    value={Array.isArray(tiposIGV) ? tiposIGV.find(t => t.codigo === detalle.tipo_igv) || null : null}
                    onChange={(e, value) => {
                      handleDetalleChange({ target: { name: 'tipo_igv', value: value ? value.codigo : '' } });
                    }}
                    isOptionEqualToValue={(option, value) => option.codigo === value.codigo}
                    loading={loadingTiposIGV}
                    disabled={ncBloquearAgregarDetalle}
                    disableClearable
                    renderInput={params => (
                      <TextField {...params} label="Tipo IGV" fullWidth />
                    )}
                  />
                </Grid>
                {isMobile && <div style={{ flexBasis: '100%', width: '100%', height: 0 }} />}
                <Grid item xs={2} sx={{ width: { xs: '100%', sm: '16em' }, minWidth: { xs: 0, sm: '16em' }, mt: { xs: 0, sm: 1 } }}>
                  <Autocomplete
                    options={unidades}
                    getOptionLabel={option => option?.nombre ? `${option.nombre} (${option.abreviatura})` : ''}
                    value={unidades.find(u => u.id === detalle.unidad_medida) || null}
                    onChange={(e, value) => {
                      handleDetalleChange({ target: { name: 'unidad_medida', value: value ? value.id : '' } });
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    disabled={ncBloquearAgregarDetalle}
                    renderInput={params => (
                      <TextField {...params} label="U.Medida" fullWidth />
                    )}
                  />
                </Grid>
                <Grid item xs={4} sx={{ width: { xs: '100%', sm: '20em' }, minWidth: { xs: 0, sm: '20em' }, mt: { xs: 0, sm: 0.5 } }}>
                  <Autocomplete
                    options={almacenesDisponibles}
                    getOptionLabel={option => option.nombre || ''}
                    value={almacenesDisponibles.find(a => a.id === detalle.almacen_id) || null}
                    onChange={(e, value) => {
                      setDetalle(d => ({ ...d, almacen_id: value ? value.id : '' }));
                      setDetalleError(err => ({ ...err, almacen: false }));
                      setDetalleErrorMsg('');
                    }}
                    inputValue={almacenInput}
                    onInputChange={(e, value) => setAlmacenInput(value)}
                    loading={loadingAlmacenes}
                    disabled={ncBloquearAgregarDetalle}
                    renderInput={params => (
                      <TextField {...params} label="Almacén" size="small" fullWidth margin="dense" error={detalleError.almacen} required
                        onKeyDown={e => { if (e.key === 'F1') { e.preventDefault(); if (detalle.producto_id) setOpenStockAlmacen(true); } }}
                      />
                    )}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    disableClearable
                  />
                </Grid>
                <Grid item xs={2} sx={{ mt: 1 }}>
                  <Tooltip title={editingDetalle === null && ncBloquearAgregarDetalle ? 'Bloqueado para este tipo de NC. Solo puedes jalarse referencia cuyos items ya están copiados.' : editingDetalle === null ? 'Agregar nuevo detalle' : 'Guardar cambios en detalle'}>
                    <span style={{ display: 'block' }}>
                      <Button
                        variant="contained"
                        color="success"
                        fullWidth
                        startIcon={editingDetalle === null ? <Add /> : <CheckCircle />}
                        onClick={editingDetalle === null ? agregarDetalle : actualizarDetalle}
                        sx={{ backgroundColor: '#e8f5e9', color: '#388e3c', fontWeight: 'bold' }}
                        disabled={ncBloquearAgregarDetalle && editingDetalle === null}
                      >
                        {editingDetalle === null ? 'Agregar' : 'Actualizar'}
                      </Button>
                    </span>
                  </Tooltip>
                </Grid>
                {detalleErrorMsg && (
                  <Grid item xs={12}>
                    <Typography color="error" sx={{ mb: 1 }}>{detalleErrorMsg}</Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
            {isMobile ? (
              <>
                <Grid item xs={12} sx={{ mt: 1 }}>
                  <TextField
                    label="Subtotal"
                    value={Number(form.subtotal).toFixed(2)}
                    fullWidth
                    disabled
                    slotProps={{
                      input: {
                        sx: { textAlign: 'center', backgroundColor: '#e3f2fd', fontWeight: 'bold' },
                        style: { textAlign: 'center' }
                      },
                      htmlInput: { style: { textAlign: 'center' } }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="IGV"
                    value={Number(form.total_igv).toFixed(2)}
                    fullWidth
                    disabled
                    slotProps={{
                      input: {
                        sx: { textAlign: 'center', backgroundColor: '#fff9c4', fontWeight: 'bold' },
                        style: { textAlign: 'center' }
                      },
                      htmlInput: { style: { textAlign: 'center' } }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Total"
                    value={Number(form.total).toFixed(2)}
                    fullWidth
                    disabled
                    slotProps={{
                      input: {
                        sx: { textAlign: 'center', backgroundColor: '#e8f5e9', fontWeight: 'bold' },
                        style: { textAlign: 'center' }
                      },
                      htmlInput: { style: { textAlign: 'center' } }
                    }}
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={4} sx={{ minWidth: '18em', mt: 2 }}>
                  <TextField
                    label="Subtotal"
                    value={Number(form.subtotal).toFixed(2)}
                    fullWidth
                    disabled
                    slotProps={{
                      input: {
                        sx: {
                          textAlign: 'center',
                          backgroundColor: '#e3f2fd',
                          fontWeight: 'bold'
                        },
                        style: { textAlign: 'center' }
                      },
                      htmlInput: { style: { textAlign: 'center' } }
                    }}
                  />
                </Grid>
                <Grid item xs={4} sx={{ minWidth: '18em', mt: 2 }}>
                  <TextField
                    label="IGV"
                    value={Number(form.total_igv).toFixed(2)}
                    fullWidth
                    disabled
                    slotProps={{
                      input: {
                        sx: {
                          textAlign: 'center',
                          backgroundColor: '#fff9c4',
                          fontWeight: 'bold'
                        },
                        style: { textAlign: 'center' }
                      },
                      htmlInput: { style: { textAlign: 'center' } }
                    }}
                  />
                </Grid>
                <Grid item xs={4} sx={{ minWidth: '18em', mt: 2 }}>
                  <TextField
                    label="Total"
                    value={Number(form.total).toFixed(2)}
                    fullWidth
                    disabled
                    slotProps={{
                      input: {
                        sx: {
                          textAlign: 'center',
                          backgroundColor: '#e8f5e9',
                          fontWeight: 'bold'
                        },
                        style: { textAlign: 'center' }
                      },
                      htmlInput: { style: { textAlign: 'center' } }
                    }}
                  />
                </Grid>
              </>
            )}
            {/* ------ BLOQUE CUOTAS DE CRÉDITO ------ */}
            {esCredito() && (
              <Grid item xs={12} sx={{ width: '55em', minWidth: '55em' }}>
                <Paper variant="outlined" sx={{ p: 2, mt: 1, borderColor: '#ff9800', borderRadius: 2, bgcolor: '#fffbf0' }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: '#ff6f00', textAlign: 'center' }}>
                    ?? Cuotas de pago (Crédito - {obtenerDiasCredito()} días)
                  </Typography>
                  
                  {/* SECCIÓN CENTRADA: Cuotas automáticas */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2, p: 1.5, bgcolor: '#fff5e1', borderRadius: 1, border: '1px solid #ffb74d' }}>
                    <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 'bold' }}>Generar cuotas automáticas:</Typography>
                    <Grid container spacing={1} sx={{ maxWidth: '550px', justifyContent: 'center' }}>
                      <Grid item xs={12} sm={5}>
                        <TextField
                          label="Dividir en cuotas"
                          type="number"
                          size="small"
                          fullWidth
                          value={numeroCuotas}
                          onChange={e => {
                            const val = Math.max(0, parseInt(e.target.value) || 0);
                            setNumeroCuotas(val);
                            if (val > 0) {
                              calcularCuotasOpcionA(val);
                            } else {
                              setCuotas([]);
                              setForm(f => ({ ...f, cuotas_json: '' }));
                            }
                          }}
                          inputProps={{ min: 0, max: 12 }}
                          helperText="0 = modo manual"
                        />
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <Alert severity="info" sx={{ py: 1, height: '56px', display: 'flex', alignItems: 'center' }}>
                          <Typography variant="body2">
                            <strong>Vencimiento base:</strong> {new Date(new Date(form.fecha_emision).getTime() + obtenerDiasCredito() * 24 * 60 * 60 * 1000).toISOString().substring(0, 10)}
                          </Typography>
                        </Alert>
                      </Grid>
                    </Grid>
                  </Box>

                  {/* Tabla de cuotas */}
                  {cuotas.length > 0 && (
                    <TableContainer component={Paper} sx={{ mb: 2, bgcolor: '#fff' }}>
                      <Table size="small">
                        <TableHead>
                          <TableRow sx={{ bgcolor: '#fff3e0' }}>
                            <TableCell align="center" sx={{ fontWeight: 'bold' }}>Cuota</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 'bold' }}>Fecha vencimiento</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold' }}>Monto (S/)</TableCell>
                            <TableCell align="center" sx={{ fontWeight: 'bold' }}>Días</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {cuotas.map((c, idx) => {
                            const hoy = new Date();
                            const venc = new Date(c.fecha);
                            const diasDiff = Math.floor((venc - hoy) / (1000 * 60 * 60 * 24));
                            return (
                              <TableRow key={idx}>
                                <TableCell align="center">#{c.numero}</TableCell>
                                <TableCell align="center">{c.fecha}</TableCell>
                                <TableCell align="right">{Number(c.monto).toFixed(2)}</TableCell>
                                <TableCell align="center">
                                  <Chip
                                    label={diasDiff > 0 ? `+${diasDiff}d` : `${diasDiff}d`}
                                    size="small"
                                    color={diasDiff > 0 ? 'success' : 'error'}
                                    variant="outlined"
                                  />
                                </TableCell>
                              </TableRow>
                            );
                          })}
                          <TableRow sx={{ bgcolor: '#f5f5f5', fontWeight: 'bold' }}>
                            <TableCell colSpan={2} align="right">TOTAL:</TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                              {cuotas.reduce((sum, c) => sum + Number(c.monto), 0).toFixed(2)}
                            </TableCell>
                            <TableCell />
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}

                  {/* Agregar cuota manual */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 1.5, bgcolor: '#fff9c4', borderRadius: 1, borderLeft: '4px solid #ff9800' }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1.5 }}>Agregar cuota manual:</Typography>
                    <Grid container spacing={1} alignItems="flex-end" sx={{ maxWidth: '550px', justifyContent: 'center' }}>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          label="Fecha vencimiento"
                          type="date"
                          size="small"
                          fullWidth
                          value={fechaCuota}
                          onChange={e => setFechaCuota(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          label="Monto (S/)"
                          type="number"
                          size="small"
                          fullWidth
                          value={montoCuota}
                          onChange={e => setMontoCuota(Number(e.target.value) || 0)}
                          inputProps={{ min: 0, step: 0.01 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Button
                          variant="contained"
                          color="success"
                          fullWidth
                          onClick={agregarCuotaManual}
                          size="small"
                          sx={{ height: '40px' }}
                        >
                          Agregar
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
              </Grid>
            )}
            {/* ---------- SWITCH OPCIONES FINANCIERAS ---------- */}
            <Grid item xs={12}>
              <FormControlLabel
                control={<Switch checked={mostrarFinanciero} onChange={() => setMostrarFinanciero(v => !v)} color="warning" />}
                label={mostrarFinanciero ? "Opciones financieras: Activo" : "Opciones financieras: Oculto"}
                sx={{ mb: 1 }}
              />
            </Grid>

            {mostrarFinanciero && (
            <>
            {/* -- BLOQUE FINANCIERO: Anticipo / Detracción / Retención -- */}
            <Grid item xs={12}>
              <Paper variant="outlined" sx={{ p: 2, mt: 1, borderColor: '#1976d2', borderRadius: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1.5, color: '#1976d2' }}>
                  Cargos y descuentos financieros
                </Typography>
                <Grid container spacing={2} alignItems="center">

                  {/* -- Anticipo -- */}
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={!!form.es_anticipo}
                          onChange={e => setForm(f => ({ ...f, es_anticipo: e.target.checked, anticipo_referencia_id: null, total_anticipos: 0 }))}
                          color="warning"
                        />
                      }
                      label={<Typography fontWeight="bold">Este comprobante ES un anticipo (no descuenta ninguno)</Typography>}
                    />
                  </Grid>

                  {!form.es_anticipo && (
                    <>
                      <Grid item xs={12} sm={5}>
                        <TextField
                          label="Anticipo de referencia"
                          value={anticipNombre}
                          size="small"
                          fullWidth
                          placeholder="Sin anticipo aplicado"
                          InputProps={{
                            readOnly: true,
                            endAdornment: (
                              <>
                                <Button size="small" onClick={() => setOpenAnticipoSearch(true)} sx={{ whiteSpace: 'nowrap', ml: 1 }}>Buscar</Button>
                                {anticipNombre && (
                                  <Button size="small" color="error" onClick={() => { setAnticipNombre(''); setForm(f => ({ ...f, anticipo_referencia_id: null, total_anticipos: 0 })); }}>✕</Button>
                                )}
                              </>
                            )
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          label="Monto anticipo a deducir"
                          type="number"
                          size="small"
                          fullWidth
                          value={form.total_anticipos}
                          onChange={e => setForm(f => ({ ...f, total_anticipos: parseFloat(e.target.value) || 0 }))}
                          inputProps={{ min: 0, step: 0.01 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          label="Total menos anticipo"
                          size="small"
                          fullWidth
                          disabled
                          value={(Number(form.total) - Number(form.total_anticipos || 0)).toFixed(2)}
                          slotProps={{ input: { sx: { backgroundColor: '#fff3e0', fontWeight: 'bold' } } }}
                        />
                      </Grid>
                    </>
                  )}

                  {/* -- Detracción -- */}
                  <Grid item xs={12} sm={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={!!form.detraccion_aplicada}
                          onChange={e => setForm(f => ({ ...f, detraccion_aplicada: e.target.checked, detraccion_monto: 0, detraccion_cuenta: '', detraccion_porcentaje_personalizado: false, detraccion_porcentaje: 12 }))}
                          color="info"
                        />
                      }
                      label={<Typography fontWeight="bold">Detracción</Typography>}
                    />
                  </Grid>
                  {form.detraccion_aplicada && (
                    <>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          label="Cuenta SUNAT"
                          name="detraccion_cuenta"
                          size="small"
                          fullWidth
                          value={form.detraccion_cuenta}
                          onChange={handleFormChange}
                          placeholder="N° cuenta detracción"
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <TextField
                          label="Monto detracción"
                          name="detraccion_monto"
                          type="number"
                          size="small"
                          fullWidth
                          disabled={!!form.detraccion_porcentaje_personalizado}
                          value={form.detraccion_monto}
                          onChange={handleFormChange}
                          inputProps={{ min: 0, step: 0.01 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!!form.detraccion_porcentaje_personalizado}
                              onChange={e => {
                                const checked = e.target.checked;
                                setForm(f => {
                                  const pct = Number(f.detraccion_porcentaje || 12);
                                  return {
                                    ...f,
                                    detraccion_porcentaje_personalizado: checked,
                                    detraccion_porcentaje: pct,
                                    detraccion_monto: checked ? Math.round(Number(f.total) * pct) / 100 : f.detraccion_monto
                                  };
                                });
                              }}
                            />
                          }
                          label="Personalizar % detracción"
                        />
                      </Grid>
                      {form.detraccion_porcentaje_personalizado && (
                        <Grid item xs={12} sm={4}>
                          <TextField
                            label="% Detracción"
                            name="detraccion_porcentaje"
                            type="number"
                            size="small"
                            fullWidth
                            value={form.detraccion_porcentaje}
                            onChange={e => {
                              const pct = Number(e.target.value);
                              setForm(f => ({
                                ...f,
                                detraccion_porcentaje: e.target.value,
                                detraccion_monto: Math.round(Number(f.total) * (Number.isFinite(pct) ? pct : 0)) / 100
                              }));
                            }}
                            inputProps={{ min: 0, max: 100, step: 0.01 }}
                          />
                        </Grid>
                      )}
                    </>
                  )}

                  {/* -- Retención -- */}
                  <Grid item xs={12} sm={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={!!form.retencion_aplicada}
                          onChange={e => setForm(f => ({ ...f, retencion_aplicada: e.target.checked, retencion_monto: 0 }))}
                          color="secondary"
                        />
                      }
                      label={<Typography fontWeight="bold">Retención</Typography>}
                    />
                  </Grid>
                  {form.retencion_aplicada && (
                    <Grid item xs={12} sm={4}>
                      <TextField
                        label="Monto retención"
                        name="retencion_monto"
                        type="number"
                        size="small"
                        fullWidth
                        value={form.retencion_monto}
                        onChange={handleFormChange}
                        inputProps={{ min: 0, step: 0.01 }}
                      />
                    </Grid>
                  )}

                  {/* -- Importe neto final -- */}
                  {(form.detraccion_aplicada || form.retencion_aplicada || (!form.es_anticipo && Number(form.total_anticipos) > 0)) && (
                    <Grid item xs={12} sm={5}>
                      <TextField
                        label="Importe neto final (a cobrar)"
                        size="small"
                        fullWidth
                        disabled
                        value={(
                          Number(form.total)
                          - Number(!form.es_anticipo ? (form.total_anticipos || 0) : 0)
                          - Number(form.detraccion_aplicada ? (form.detraccion_monto || 0) : 0)
                          - Number(form.retencion_aplicada ? (form.retencion_monto || 0) : 0)
                        ).toFixed(2)}
                        slotProps={{ input: { sx: { backgroundColor: '#e8f5e9', fontWeight: 'bold', fontSize: 16 } } }}
                      />
                    </Grid>
                  )}

                </Grid>
              </Paper>
            </Grid>
            </>
            )}
            <Grid item xs={12}>
              <FormControlLabel
                control={<Switch checked={mostrarResumenIGV} onChange={() => setMostrarResumenIGV(v => !v)} color="primary" />}
                label={mostrarResumenIGV ? "Resumen por tipo de IGV: Activo" : "Resumen por tipo de IGV: Oculto"}
              />
            </Grid>
            {mostrarResumenIGV && (
              <Grid item xs={12} sx={{ width: '100%' }}>
                <Typography variant="h6" gutterBottom sx={{ width: '100%', textAlign: 'center' }}>Resumen por tipo de IGV</Typography>
                <TableContainer component={Paper} sx={{ width: '100%' }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Tipo IGV</TableCell>
                        <TableCell align="right">Base Imponible</TableCell>
                        <TableCell align="right">IGV</TableCell>
                        <TableCell align="right">Total</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(() => {
                        // Agrupar detalles por código IGV y mostrar descripción
                        const codigosGratuitos = ['21','31','32','33','34','35'];
                        const resumen = {};
                        form.detalles.forEach(d => {
                          const tipoIGV = Array.isArray(tiposIGV) ? tiposIGV.find(t => t.codigo === d.tipo_igv) : undefined;
                          const codigo = tipoIGV?.codigo || d.tipo_igv || 'Otro';
                          const descripcion = tipoIGV?.descripcion || d.tipo_igv || 'Otro';
                          if (!resumen[codigo]) resumen[codigo] = { descripcion, base: 0, igv: 0, total: 0, esGratuito: codigosGratuitos.includes(codigo) };
                          if (codigosGratuitos.includes(codigo)) {
                            resumen[codigo].base += parseFloat(d.subtotal) || 0;
                            resumen[codigo].igv += 0;
                            resumen[codigo].total += 0;
                          } else {
                            resumen[codigo].base += parseFloat(d.subtotal) || 0;
                            resumen[codigo].igv += parseFloat(d.igv_monto) || 0;
                            resumen[codigo].total += parseFloat(d.total) || 0;
                          }
                        });
                        // Mostrar solo los tipos con base > 0
                        const filas = Object.entries(resumen).filter(([_, v]) => v.base > 0);
                        // Calcular totales generales, excluyendo gratuitos del total general
                        const totalBase = filas.reduce((a, [_, v]) => v.esGratuito ? a : a + v.base, 0);
                        const totalIGV = filas.reduce((a, [_, v]) => v.esGratuito ? a : a + v.igv, 0);
                        const totalTotal = filas.reduce((a, [_, v]) => v.esGratuito ? a : a + v.total, 0);
                        return <>
                          {filas.map(([codigo, v]) => (
                            <TableRow key={codigo}>
                              <TableCell>{v.descripcion} ({codigo})</TableCell>
                              <TableCell align="right">S/ {v.base.toFixed(2)}</TableCell>
                              <TableCell align="right">S/ {v.igv.toFixed(2)}</TableCell>
                              <TableCell align="right">S/ {v.total.toFixed(2)}</TableCell>
                            </TableRow>
                          ))}
                          <TableRow sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                            <TableCell><b>Totales</b></TableCell>
                            <TableCell align="right"><b>S/ {totalBase.toFixed(2)}</b></TableCell>
                            <TableCell align="right"><b>S/ {totalIGV.toFixed(2)}</b></TableCell>
                            <TableCell align="right"><b>S/ {totalTotal.toFixed(2)}</b></TableCell>
                          </TableRow>
                        </>;
                      })()}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: { xs: 2, sm: 3 }, pb: { xs: 2, sm: 1 }, gap: 1 }}>
          {!isMobile && <Button onClick={handleClose} startIcon={<Cancel />} color="error" variant="contained">Cancelar</Button>}
          <Button onClick={handleSubmit} disabled={guardando} variant="contained" color="primary" startIcon={<CloudUpload />} fullWidth={isMobile}>{guardando ? 'Guardando...' : 'Guardar Nota de Crédito'}</Button>
        </DialogActions>
      </Dialog>
    {/* Popup de datos adicionales */}
    <Dialog open={openDatosAdicionales} onClose={handleCloseDatosAdicionales} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 'bold' }}>Datos adicionales</DialogTitle>
      <DialogContent sx={{ pt: 1, pb: 0 }}>
        <TextField
          label="Orden de Compra"
          value={ordenCompraAdicional}
          onChange={e => setOrdenCompraAdicional(e.target.value)}
          fullWidth
          margin="dense"
          placeholder="Nro. orden de compra del cliente..."
        />
        <TextField
          label="Placa"
          value={placaAdicional}
          onChange={e => setPlacaAdicional(e.target.value)}
          fullWidth
          margin="dense"
          placeholder="Ingrese la placa..."
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDatosAdicionales} color="error" variant="contained" startIcon={<Cancel />}>Cerrar</Button>
      </DialogActions>
    </Dialog>
    {/* Búsqueda de comprobante anticipo de referencia */}
    <Dialog open={openAnticipoSearch} onClose={() => setOpenAnticipoSearch(false)} maxWidth="md" fullWidth>
      <DialogTitle sx={{ bgcolor: '#f57c00', color: '#fff', fontWeight: 'bold', fontSize: 20 }}>
        Seleccionar comprobante de anticipo
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2, mb: 2 }}>
          <TextField
            placeholder="Buscar por serie, número o cliente..."
            value={filtroAnticipo}
            onChange={e => setFiltroAnticipo(e.target.value)}
            size="small"
            fullWidth
          />
        </Box>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Serie</TableCell>
                <TableCell>Número</TableCell>
                <TableCell>Cliente</TableCell>
                <TableCell>Fecha</TableCell>
                <TableCell align="right">Total</TableCell>
                <TableCell align="center">Seleccionar</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {anticiposDisponibles.map(a => (
                <TableRow key={a.id}>
                  <TableCell>{a.serie}</TableCell>
                  <TableCell>{a.numero}</TableCell>
                  <TableCell>{clientes.find(x => x.id === a.cliente_id)?.razon_social || a.cliente_id}</TableCell>
                  <TableCell>{a.fecha_emision?.substring(0, 10)}</TableCell>
                  <TableCell align="right">{Number(a.total).toFixed(2)}</TableCell>
                  <TableCell align="center">
                    <Button size="small" variant="contained" color="warning" onClick={() => {
                      setForm(f => ({ ...f, anticipo_referencia_id: a.id, total_anticipos: Number(a.total) || 0 }));
                      setAnticipNombre(`${a.serie}-${a.numero}`);
                      setOpenAnticipoSearch(false);
                    }}>
                      Seleccionar
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {anticiposDisponibles.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No se encontraron comprobantes marcados como anticipo
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenAnticipoSearch(false)} color="error" variant="contained" startIcon={<Cancel />}>Cerrar</Button>
      </DialogActions>
    </Dialog>

    <Dialog open={openReferenciaNc} onClose={() => setOpenReferenciaNc(false)} maxWidth="md" fullWidth>
      <DialogTitle>Seleccionar Comprobante de Referencia</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5, mb: 1 }}>
          <Grid item xs={4}>
            <TextField
              select
              fullWidth
              label="Tipo Documento"
              value={String(form.serie || '').toUpperCase().startsWith('B') ? '03' : '01'}
              disabled
              helperText="Según la serie: F = Factura, B = Boleta"
            >
              <MenuItem value="01">Factura (01)</MenuItem>
              <MenuItem value="03">Boleta (03)</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={8}>
            <TextField
              fullWidth
              label="Buscar referencia"
              value={searchReferenciaNc}
              onChange={(e) => setSearchReferenciaNc(e.target.value)}
              placeholder="Serie, número, documento o cliente"
            />
          </Grid>
        </Grid>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Serie</TableCell>
                <TableCell>Número</TableCell>
                <TableCell>Cliente</TableCell>
                <TableCell>Fecha</TableCell>
                <TableCell align="right">Total</TableCell>
                <TableCell align="center">Acción</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {referenciasNc.map((ref) => (
                <TableRow key={ref.id}>
                  <TableCell>{ref.serie}</TableCell>
                  <TableCell>{String(ref.numero).padStart(8, '0')}</TableCell>
                  <TableCell>{ref.razon_social || ref.numero_documento || ref.cliente_id}</TableCell>
                  <TableCell>{ref.fecha_emision?.substring(0, 10)}</TableCell>
                  <TableCell align="right">{Number(ref.total || 0).toFixed(2)}</TableCell>
                  <TableCell align="center">
                    <Button size="small" variant="contained" onClick={() => seleccionarReferenciaNc(ref)}>
                      Seleccionar
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {referenciasNc.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No hay comprobantes para seleccionar
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenReferenciaNc(false)} color="error" variant="contained" startIcon={<Cancel />}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>

    {/* 🔨 DIÁLOGO DE ANULACIÓN ELECTRÓNICA */}
    <Dialog open={openAnulacion} onClose={() => setOpenAnulacion(false)} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ bgcolor: '#c62828', color: '#fff', fontWeight: 'bold', fontSize: 18 }}>
        Anular Comprobante Electrónicamente
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mt: 2, mb: 2 }}>
          ⚠️ <strong>Atención:</strong> La anulación electrónica se reportará a SUNAT. Este proceso NO puede deshacerse.
        </Alert>
        {BoletaAAnular && (
          <Box sx={{ mb: 2, p: 1.5, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
            <Typography><strong>Comprobante:</strong> {BoletaAAnular.serie}-{String(BoletaAAnular.numero).padStart(8, '0')}</Typography>
            <Typography><strong>Cliente:</strong> {clientes.find(c => c.id === BoletaAAnular.cliente_id)?.razon_social || 'N/A'}</Typography>
            <Typography><strong>Total:</strong> S/ {Number(BoletaAAnular.total).toFixed(2)}</Typography>
            <Typography><strong>Fecha Emisión:</strong> {BoletaAAnular.fecha_emision?.substring(0, 10)}</Typography>
            <Typography sx={{ mt: 1, color: '#d32f2f', fontWeight: 'bold' }}>
              Estado CPE: {BoletaAAnular.estado_cpe}
            </Typography>
            {BoletaAAnular.ultimo_estado_anulacion && (
              <Typography sx={{ mt: 0.5, color: '#ef6c00', fontWeight: 'bold' }}>
                Estado anulación: {BoletaAAnular.ultimo_estado_anulacion}
              </Typography>
            )}
          </Box>
        )}
        <TextField
          label="Motivo de anulación (6-120 caracteres)"
          value={motivoAnulacion}
          onChange={e => setMotivoAnulacion(e.target.value.substring(0, 120))}
          fullWidth
          multiline
          rows={3}
          margin="normal"
          placeholder="Ej: anulación por solicitud del cliente, error en datos, etc."
          error={motivoAnulacion.length < 6 && motivoAnulacion.length > 0}
          helperText={motivoAnulacion.length < 6 && motivoAnulacion.length > 0 ? 'Mínimo 6 caracteres' : `${motivoAnulacion.length}/120`}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenAnulacion(false)} color="error" variant="outlined" startIcon={<Cancel />} disabled={procesandoAnulacion}>
          Cancelar
        </Button>
        <Button
          onClick={async () => {
            if (procesandoAnulacion) return;
            if (motivoAnulacion.trim().length < 6) {
              alert('El motivo debe tener Mínimo 6 caracteres');
              return;
            }
            setProcesandoAnulacion(true);
            try {
              const response = await axios.post(`/api/comprobante/${BoletaAAnular.id}/anular`, {
                motivo: motivoAnulacion,
                usuario: usuarioLogueado?.username || usuarioLogueado?.email || 'sistema'
              });
              const data = response?.data || {};
              const ticketTxt = data.ticket ? `\nTicket SUNAT: ${data.ticket}` : '';
              alert(`✓ anulación enviada a SUNAT.${ticketTxt}\nEstado: ${data.estado_anulacion || 'ACEPTADA'}`);
              setOpenAnulacion(false);
              setBoletaAAnular(null);
              setMotivoAnulacion('');
              fetchBoletas();
            } catch (err) {
              const errorMsg = err.response?.data?.error || err.message;
              const validationErrors = err.response?.data?.validationErrors || [];
              if (validationErrors.length > 0) {
                alert('Errores de validación:\n• ' + validationErrors.join('\n• '));
              } else {
                alert('Error al procesar anulación: ' + errorMsg);
              }
            } finally {
              setProcesandoAnulacion(false);
            }
          }}
          color="error"
          variant="contained"
          startIcon={<Gavel />}
          disabled={motivoAnulacion.trim().length < 6 || procesandoAnulacion}
        >
          {procesandoAnulacion ? 'Procesando…' : 'Proceder con anulación'}
        </Button>
      </DialogActions>
    </Dialog>

    <Dialog open={openPdfDialog} onClose={cerrarDialogoPdf} maxWidth="sm" fullWidth>
      <DialogTitle>Descargar PDF</DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mt: 1, mb: 2 }}>
          Selecciona el formato de impresión. La descarga se hace directamente desde el backend y el formato elegido puede quedar como predeterminado.
        </Alert>
        
        {pdfResolucionCargando ? (
          <Box sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
            <Typography variant="body2">Resolviendo plantilla...</Typography>
          </Box>
        ) : pdfResolucion && pdfResolucion.plantilla_nombre ? (
          <Alert severity="success" sx={{ mb: 2 }}>
            <Typography variant="body2"><strong>Plantilla:</strong> {pdfResolucion.plantilla_nombre}</Typography>
            <Typography variant="body2"><strong>Ámbito:</strong> {pdfResolucion.scope === 'Global' ? 'Global (todas las sucursales)' : pdfResolucion.scope === 'Specific' ? 'Específica para esta sucursal' : 'Heredada de global'}</Typography>
            {pdfResolucion.is_inherited && (
              <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: '#1976d2' }}>
                ?? Esta sucursal hereda la asignación de la configuración global
              </Typography>
            )}
          </Alert>
        ) : null}
        
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' }, gap: 1.5, mb: 2 }}>
          {[
            { codigo: 'A4', titulo: 'A4', detalle: 'Formato completo' },
            { codigo: 'A5', titulo: 'A5', detalle: 'Formato compacto' },
            { codigo: 'T80', titulo: 'Ticket 80mm', detalle: 'Impresora térmica' }
          ].map((item) => (
            <Paper
              key={item.codigo}
              onClick={() => {
                setPdfFormatoSeleccionado(item.codigo);
                actualizarResolucionFormato(item.codigo);
              }}
              sx={{
                p: 2,
                cursor: 'pointer',
                border: '2px solid',
                borderColor: pdfFormatoSeleccionado === item.codigo ? '#1976d2' : '#d0d7de',
                backgroundColor: pdfFormatoSeleccionado === item.codigo ? '#e3f2fd' : '#fff'
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 'bold', textAlign: 'center' }}>{item.titulo}</Typography>
              <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.secondary' }}>{item.detalle}</Typography>
              {localStorage.getItem('nota_credito_pdf_formato_default') === item.codigo && (
                <Chip label="Predeterminado" color="primary" size="small" sx={{ mt: 1, display: 'flex', mx: 'auto', width: 'fit-content' }} />
              )}
            </Paper>
          ))}
        </Box>
        <FormControlLabel
          control={
            <Switch
              checked={guardarPdfComoPredeterminado}
              onChange={(e) => setGuardarPdfComoPredeterminado(e.target.checked)}
              color="primary"
            />
          }
          label={`Guardar ${pdfFormatoSeleccionado} como formato predeterminado`}
        />
        {BoletaPdfTarget && (
          <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
            Documento: {BoletaPdfTarget.serie}-{String(BoletaPdfTarget.numero || '').padStart(8, '0')}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={cerrarDialogoPdf} disabled={pdfDescargando}>Cancelar</Button>
        <Button onClick={descargarPdfBoleta} variant="contained" disabled={pdfDescargando}>
          {pdfDescargando ? 'Descargando...' : `Descargar ${pdfFormatoSeleccionado}`}
        </Button>
      </DialogActions>
    </Dialog>

    <ClienteRapidoDialog
      open={openNuevoCliente}
      onClose={() => setOpenNuevoCliente(false)}
      onClienteCreado={(cliente) => {
        debouncedFetchClientes.cancel();
        ++fetchClienteGenRef.current;
        setClientes(prev => [cliente, ...prev]);
        setForm(f => ({ ...f, cliente_id: cliente.id }));
        skipClienteSearch.current = true;
        setClienteInput(cliente.razon_social || '');
        setOpenNuevoCliente(false);
      }}
      initialQuery={clienteInput}
    />
    <ProductoRapidoDialog
      open={openNuevoProducto}
      onClose={() => setOpenNuevoProducto(false)}
      onProductoCreado={(producto) => {
        setProductos(prev => [producto, ...prev]);
        setDetalle(d => ({
          ...d,
          producto_id: producto.id,
          unidad_medida: producto.unidad_medida_id || d.unidad_medida,
          precio_unitario: producto.precio != null ? producto.precio : d.precio_unitario
        }));
        setProductoInput(producto?.nombre || '');
        setOpenNuevoProducto(false);
      }}
      initialNombre={productoInput}
    />
    <ProductoBuscadorDialog
      open={openBuscadorProducto}
      onClose={() => setOpenBuscadorProducto(false)}
      onSelect={handleBuscadorSelectNC}
    />
    <StockAlmacenesDialog
      open={openStockAlmacen}
      onClose={() => setOpenStockAlmacen(false)}
      productoId={detalle.producto_id}
      productoNombre={detalle.descripcion_producto}
    />

    <Dialog open={!!correlativoError} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'warning.dark' }}>
        <Warning color="warning" /> Número de correlativo duplicado
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 1.5 }}>{correlativoError?.error}</Typography>
        <Typography variant="body2" color="text.secondary">
          ¿Regularizar la serie <strong>{correlativoError?.serie}</strong> al número <strong>{correlativoError?.numero_siguiente}</strong> y volver a intentar?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setCorrelativoError(null)}>No, cancelar</Button>
        <Button variant="contained" color="warning" onClick={handleFixCorrelativoNC} disabled={fixingCorrelativo}>
          {fixingCorrelativo ? 'Regularizando...' : 'Sí, regularizar serie'}
        </Button>
      </DialogActions>
    </Dialog>

    </Box>
    <WhatsAppDialog
      open={wspDialog.open}
      onClose={() => setWspDialog({ open: false, data: null })}
      docTipo="comprobante"
      tipoDoc="07"
      docId={wspDialog.data?.id}
      clienteId={wspDialog.data?.cliente_id}
      serie={wspDialog.data?.serie || ''}
      numero={wspDialog.data?.numero || ''}
      fecha={wspDialog.data?.fecha_emision || ''}
      total={wspDialog.data?.total || 0}
      moneda={wspDialog.data?.moneda || 'PEN'}
      clienteNombre={clientes.find(x => x.id === wspDialog.data?.cliente_id)?.razon_social || ''}
    />
</Box>
  );
};
export default NotaCreditoPage;



